/**
 * 机器翻译词条（gen-translations.mjs 自动生成，勿手改）
 * key = 中文原文 → { en, ja, de, fr, es }
 */
export const AUTO_DICT: Record<string, { en?: string; ja?: string; de?: string; fr?: string; es?: string }> = {
  "/api/v1/scan/summary": {
    "en": "/api/v1/scan/summary",
    "ja": "/api/v1/scan/summary",
    "de": "/api/v1/scan/summary",
    "fr": "/api/v1/scan/summary",
    "es": "/api/v1/scan/summary"
  },
  "/api/v1/scan/gaps": {
    "en": "/api/v1/scan/gaps",
    "ja": "/api/v1/scan/gaps",
    "de": "/api/v1/scan/gaps",
    "fr": "/api/v1/scan/gaps",
    "es": "/api/v1/scan/gaps"
  },
  "/api/v1/scan": {
    "en": "/api/v1/scan",
    "ja": "/api/v1/scan",
    "de": "/api/v1/scan",
    "fr": "/api/v1/scan",
    "es": "/api/v1/scan"
  },
  "商品总数": {
    "en": "Total Products",
    "ja": "商品総数",
    "de": "Gesamtprodukte",
    "fr": "Total produits",
    "es": "Total productos"
  },
  "平均完整度": {
    "en": "Avg Completeness",
    "ja": "平均完全度",
    "de": "Durchschn. Vollständigkeit",
    "fr": "Complétude moyenne",
    "es": "Integridad promedio"
  },
  "严重缺口商品": {
    "en": "Critical Gap Products",
    "ja": "重大欠落商品",
    "de": "Kritische Lückenprodukte",
    "fr": "Produits à lacunes critiques",
    "es": "Productos con brechas críticas"
  },
  "GTIN 缺失/无效": {
    "en": "GTIN Missing/Invalid",
    "ja": "GTIN 欠落/無効",
    "de": "GTIN fehlt/ungültig",
    "fr": "GTIN manquant/invalide",
    "es": "GTIN faltante/inválido"
  },
  "🔍 全店扫描": {
    "en": "🔍 Full Store Scan",
    "ja": "🔍 全店スキャン",
    "de": "🔍 Vollständiger Shop-Scan",
    "fr": "🔍 Scan complet de la boutique",
    "es": "🔍 Escaneo completo de la tienda"
  },
  "商品": {
    "en": "Product",
    "ja": "商品",
    "de": "Produkt",
    "fr": "Produit",
    "es": "Producto"
  },
  "品类": {
    "en": "Category",
    "ja": "カテゴリ",
    "de": "Kategorie",
    "fr": "Catégorie",
    "es": "Categoría"
  },
  "完整度": {
    "en": "Completeness",
    "ja": "完全度",
    "de": "Vollständigkeit",
    "fr": "Complétude",
    "es": "Integridad"
  },
  "缺口数": {
    "en": "Gap Count",
    "ja": "欠落数",
    "de": "Lückenanzahl",
    "fr": "Nombre de lacunes",
    "es": "Número de brechas"
  },
  "操作": {
    "en": "Actions",
    "ja": "操作",
    "de": "Aktionen",
    "fr": "Actions",
    "es": "Acciones"
  },
  "🤖 AI 提取": {
    "en": "🤖 AI Extract",
    "ja": "🤖 AI抽出",
    "de": "🤖 KI-Extraktion",
    "fr": "🤖 Extraction IA",
    "es": "🤖 Extracción IA"
  },
  "📋 生成 Schema": {
    "en": "📋 Generate Schema",
    "ja": "📋 Schema生成",
    "de": "📋 Schema generieren",
    "fr": "📋 Générer Schema",
    "es": "📋 Generar Schema"
  },
  "推荐": {
    "en": "Recommended",
    "ja": "おすすめ",
    "de": "Empfohlen",
    "fr": "Recommandé",
    "es": "Recomendado"
  },
  "暂无数据 — 点击\"全店扫描\"": {
    "en": "No data — Click \"Full Store Scan\"",
    "ja": "データなし — 「全店スキャン」をクリック",
    "de": "Keine Daten — Klicken Sie auf \"Vollständiger Shop-Scan\"",
    "fr": "Aucune donnée — Cliquez sur \"Scan complet de la boutique\"",
    "es": "Sin datos — Haga clic en \"Escaneo completo de la tienda\""
  },
  "/api/v1/extract?status=draft": {
    "en": "/api/v1/extract?status=draft",
    "ja": "/api/v1/extract?status=draft",
    "de": "/api/v1/extract?status=draft",
    "fr": "/api/v1/extract?status=draft",
    "es": "/api/v1/extract?status=draft"
  },
  "待审核提取草稿": {
    "en": "Pending Review Extraction Drafts",
    "ja": "審査待ち抽出下書き",
    "de": "Ausstehende Extraktionsentwürfe",
    "fr": "Brouillons d'extraction en attente",
    "es": "Borradores de extracción pendientes"
  },
  "图像提取": {
    "en": "Image Extraction",
    "ja": "画像抽出",
    "de": "Bildextraktion",
    "fr": "Extraction d'image",
    "es": "Extracción de imagen"
  },
  "✓ 回写 Shopify": {
    "en": "✓ Write Back to Shopify",
    "ja": "✓ Shopifyに書き戻し",
    "de": "✓ Zurückschreiben in Shopify",
    "fr": "✓ Réécrire dans Shopify",
    "es": "✓ Escribir de vuelta a Shopify"
  },
  "✕ 拒绝": {
    "en": "✕ Reject",
    "ja": "✕ 拒否",
    "de": "✕ Ablehnen",
    "fr": "✕ Rejeter",
    "es": "✕ Rechazar"
  },
  "暂无草稿 — 在缺口扫描页对商品执行\"AI 提取\"": {
    "en": "No drafts — Run \"AI Extract\" on products in Gap Scan page",
    "ja": "下書きなし — 欠落スキャンページで商品に「AI抽出」を実行",
    "de": "Keine Entwürfe — Führen Sie \"KI-Extraktion\" für Produkte auf der Lückenscan-Seite aus",
    "fr": "Aucun brouillon — Exécutez \"Extraction IA\" sur les produits dans la page de scan des lacunes",
    "es": "Sin borradores — Ejecute \"Extracción IA\" en productos en la página de escaneo de brechas"
  },
  "/api/v1/schema": {
    "en": "/api/v1/schema",
    "ja": "/api/v1/schema",
    "de": "/api/v1/schema",
    "fr": "/api/v1/schema",
    "es": "/api/v1/schema"
  },
  "JSON-LD Schema 生成记录": {
    "en": "JSON-LD Schema Generation Records",
    "ja": "JSON-LD Schema生成記録",
    "de": "JSON-LD Schema-Generierungsaufzeichnungen",
    "fr": "Enregistrements de génération de Schema JSON-LD",
    "es": "Registros de generación de Schema JSON-LD"
  },
  "Schema 类型": {
    "en": "Schema Type",
    "ja": "Schemaタイプ",
    "de": "Schema-Typ",
    "fr": "Type de Schema",
    "es": "Tipo de Schema"
  },
  "状态": {
    "en": "Status",
    "ja": "ステータス",
    "de": "Status",
    "fr": "Statut",
    "es": "Estado"
  },
  "时间": {
    "en": "Time",
    "ja": "時間",
    "de": "Zeit",
    "fr": "Temps",
    "es": "Hora"
  },
  "已生成": {
    "en": "Generated",
    "ja": "生成済み",
    "de": "Generiert",
    "fr": "Généré",
    "es": "Generado"
  },
  "注入店铺": {
    "en": "Injected to Store",
    "ja": "ストアに注入",
    "de": "In Shop eingefügt",
    "fr": "Injecté dans la boutique",
    "es": "Inyectado en la tienda"
  },
  "暂无记录": {
    "en": "No records",
    "ja": "記録なし",
    "de": "Keine Aufzeichnungen",
    "fr": "Aucun enregistrement",
    "es": "Sin registros"
  },
  "/api/v1/feeds": {
    "en": "/api/v1/feeds",
    "ja": "/api/v1/feeds",
    "de": "/api/v1/feeds",
    "fr": "/api/v1/feeds",
    "es": "/api/v1/feeds"
  },
  "shop": {
    "en": "Shop",
    "ja": "ショップ",
    "de": "Shop",
    "fr": "Boutique",
    "es": "Tienda"
  },
  "渠道": {
    "en": "Channel",
    "ja": "チャネル",
    "de": "Kanal",
    "fr": "Canal",
    "es": "Canal"
  },
  "格式": {
    "en": "Format",
    "ja": "フォーマット",
    "de": "Format",
    "fr": "Format",
    "es": "Formato"
  },
  "商品数": {
    "en": "Product Count",
    "ja": "商品数",
    "de": "Produktanzahl",
    "fr": "Nombre de produits",
    "es": "Número de productos"
  },
  "生成时间": {
    "en": "Generated Time",
    "ja": "生成時間",
    "de": "Generierungszeit",
    "fr": "Heure de génération",
    "es": "Hora de generación"
  },
  "⬇ 下载": {
    "en": "⬇ Download",
    "ja": "⬇ ダウンロード",
    "de": "⬇ Herunterladen",
    "fr": "⬇ Télécharger",
    "es": "⬇ Descargar"
  },
  "暂无导出记录": {
    "en": "No export records",
    "ja": "エクスポート記録なし",
    "de": "Keine Exportaufzeichnungen",
    "fr": "Aucun enregistrement d'exportation",
    "es": "Sin registros de exportación"
  },
  "产品数据结构化与 AI 渠道优化 — 字段缺口 · 多模态提取 · Schema · 多渠道 Feed": {
    "en": "Product Data Structuring & AI Channel Optimization — Field Gaps · Multimodal Extraction · Schema · Multi-Channel Feeds",
    "ja": "製品データ構造化とAIチャネル最適化 — フィールド欠落 · マルチモーダル抽出 · Schema · マルチチャネルフィード",
    "de": "Produktdatenstrukturierung & KI-Kanaloptimierung — Feldlücken · Multimodale Extraktion · Schema · Multi-Channel-Feeds",
    "fr": "Structuration des données produit & optimisation des canaux IA — Lacunes de champs · Extraction multimodale · Schema · Flux multi-canaux",
    "es": "Estructuración de datos de producto y optimización de canales con IA — Brechas de campos · Extracción multimodal · Schema · Feeds multicanal"
  },
  "字段缺口": {
    "en": "Field Gap",
    "ja": "フィールドギャップ",
    "de": "Feldlücke",
    "fr": "Écart de champ",
    "es": "Brecha de campo"
  },
  "提取审核": {
    "en": "Extraction Review",
    "ja": "抽出レビュー",
    "de": "Extraktionsprüfung",
    "fr": "Révision d'extraction",
    "es": "Revisión de extracción"
  },
  "多渠道 Feed": {
    "en": "Multi-Channel Feed",
    "ja": "マルチチャネルフィード",
    "de": "Multi-Channel-Feed",
    "fr": "Flux multicanal",
    "es": "Feed multicanal"
  },
  "设置": {
    "en": "Settings",
    "ja": "設定",
    "de": "Einstellungen",
    "fr": "Paramètres",
    "es": "Configuración"
  },
  "/api/v1/sov": {
    "en": "/api/v1/sov",
    "ja": "/api/v1/sov",
    "de": "/api/v1/sov",
    "fr": "/api/v1/sov",
    "es": "/api/v1/sov"
  },
  "/api/v1/sov/gap-queries": {
    "en": "/api/v1/sov/gap-queries",
    "ja": "/api/v1/sov/gap-queries",
    "de": "/api/v1/sov/gap-queries",
    "fr": "/api/v1/sov/gap-queries",
    "es": "/api/v1/sov/gap-queries"
  },
  "/api/v1/alerts": {
    "en": "/api/v1/alerts",
    "ja": "/api/v1/alerts",
    "de": "/api/v1/alerts",
    "fr": "/api/v1/alerts",
    "es": "/api/v1/alerts"
  },
  "加载中...（先在\"监测配置\"添加查询词并运行探测）": {
    "en": "Loading... (Add query words in \"Monitor Config\" and run probe first)",
    "ja": "読み込み中...（まず「監視設定」でクエリワードを追加し、プローブを実行してください）",
    "de": "Laden... (Fügen Sie zuerst in \"Überwachungskonfiguration\" Suchbegriffe hinzu und führen Sie den Probe aus)",
    "fr": "Chargement... (Ajoutez d'abord des mots-clés dans \"Configuration de surveillance\" et exécutez la sonde)",
    "es": "Cargando... (Primero agregue palabras de consulta en \"Configuración de monitoreo\" y ejecute la sonda)"
  },
  "AI Share-of-Voice（30 天）": {
    "en": "AI Share-of-Voice (30 days)",
    "ja": "AI Share-of-Voice（30日間）",
    "de": "AI Share-of-Voice (30 Tage)",
    "fr": "AI Share-of-Voice (30 jours)",
    "es": "AI Share-of-Voice (30 días)"
  },
  "暂无数据 — 运行探测后查看": {
    "en": "No data — Check after running probe",
    "ja": "データなし — プローブ実行後に確認",
    "de": "Keine Daten — Nach Ausführung des Probes prüfen",
    "fr": "Aucune donnée — Vérifier après exécution de la sonde",
    "es": "Sin datos — Verifique después de ejecutar la sonda"
  },
  "分引擎表现（自有品牌提及率）": {
    "en": "Performance by Engine (Own Brand Mention Rate)",
    "ja": "エンジン別パフォーマンス（自社ブランド言及率）",
    "de": "Leistung nach Engine (Eigenmarken-Erwähnungsrate)",
    "fr": "Performance par moteur (Taux de mention de marque propre)",
    "es": "Rendimiento por motor (Tasa de mención de marca propia)"
  },
  "引擎": {
    "en": "Engine",
    "ja": "エンジン",
    "de": "Engine",
    "fr": "Moteur",
    "es": "Motor"
  },
  "探测次数": {
    "en": "Probe Count",
    "ja": "プローブ回数",
    "de": "Probe-Anzahl",
    "fr": "Nombre de sondes",
    "es": "Número de sondas"
  },
  "提及率": {
    "en": "Mention Rate",
    "ja": "言及率",
    "de": "Erwähnungsrate",
    "fr": "Taux de mention",
    "es": "Tasa de mención"
  },
  "差距查询词（竞品被推荐而你没有）": {
    "en": "Gap Queries (Competitors recommended but you are not)",
    "ja": "ギャップクエリ（競合が推薦され、あなたはされていない）",
    "de": "Gap-Abfragen (Wettbewerber werden empfohlen, Sie nicht)",
    "fr": "Requêtes d'écart (Concurrents recommandés mais pas vous)",
    "es": "Consultas de brecha (Competidores recomendados pero usted no)"
  },
  "查询词": {
    "en": "Query",
    "ja": "クエリワード",
    "de": "Suchbegriff",
    "fr": "Mot-clé",
    "es": "Palabra de consulta"
  },
  "被推荐的竞品": {
    "en": "Recommended Competitors",
    "ja": "推薦された競合",
    "de": "Empfohlene Wettbewerber",
    "fr": "Concurrents recommandés",
    "es": "Competidores recomendados"
  },
  "暂无差距查询词 🎉": {
    "en": "No gap queries 🎉",
    "ja": "ギャップクエリなし 🎉",
    "de": "Keine Gap-Abfragen 🎉",
    "fr": "Aucune requête d'écart 🎉",
    "es": "Sin consultas de brecha 🎉"
  },
  "/api/v1/queries": {
    "en": "/api/v1/queries",
    "ja": "/api/v1/queries",
    "de": "/api/v1/queries",
    "fr": "/api/v1/queries",
    "es": "/api/v1/queries"
  },
  "/api/v1/competitors": {
    "en": "/api/v1/competitors",
    "ja": "/api/v1/competitors",
    "de": "/api/v1/competitors",
    "fr": "/api/v1/competitors",
    "es": "/api/v1/competitors"
  },
  "/api/v1/settings": {
    "en": "/api/v1/settings",
    "ja": "/api/v1/settings",
    "de": "/api/v1/settings",
    "fr": "/api/v1/settings",
    "es": "/api/v1/settings"
  },
  "已保存": {
    "en": "Saved",
    "ja": "保存済み",
    "de": "Gespeichert",
    "fr": "Enregistré",
    "es": "Guardado"
  },
  "品牌设置": {
    "en": "Brand Settings",
    "ja": "ブランド設定",
    "de": "Markeneinstellungen",
    "fr": "Paramètres de marque",
    "es": "Configuración de marca"
  },
  "品牌名（用于提及识别）": {
    "en": "Brand Name (for mention recognition)",
    "ja": "ブランド名（言及認識用）",
    "de": "Markenname (für Erwähnungserkennung)",
    "fr": "Nom de marque (pour la reconnaissance de mentions)",
    "es": "Nombre de marca (para reconocimiento de menciones)"
  },
  "保存": {
    "en": "Save",
    "ja": "保存",
    "de": "Speichern",
    "fr": "Enregistrer",
    "es": "Guardar"
  },
  "🚀 立即运行探测": {
    "en": "🚀 Run Probe Now",
    "ja": "🚀 今すぐプローブを実行",
    "de": "🚀 Probe jetzt ausführen",
    "fr": "🚀 Exécuter la sonde maintenant",
    "es": "🚀 Ejecutar sonda ahora"
  },
  "如 \"best portable blender under $100\"": {
    "en": "e.g. \"best portable blender under $100\"",
    "ja": "例：「best portable blender under $100」",
    "de": "z.B. \"best portable blender under $100\"",
    "fr": "ex. \"best portable blender under $100\"",
    "es": "ej. \"best portable blender under $100\""
  },
  "添加": {
    "en": "Add",
    "ja": "追加",
    "de": "Hinzufügen",
    "fr": "Ajouter",
    "es": "Agregar"
  },
  "删除": {
    "en": "Delete",
    "ja": "削除",
    "de": "Löschen",
    "fr": "Supprimer",
    "es": "Eliminar"
  },
  "竞品品牌名": {
    "en": "Competitor Brand Name",
    "ja": "競合ブランド名",
    "de": "Wettbewerber-Markenname",
    "fr": "Nom de marque concurrent",
    "es": "Nombre de marca competidora"
  },
  "/api/v1/probes": {
    "en": "/api/v1/probes",
    "ja": "/api/v1/probes",
    "de": "/api/v1/probes",
    "fr": "/api/v1/probes",
    "es": "/api/v1/probes"
  },
  "关闭": {
    "en": "Close",
    "ja": "閉じる",
    "de": "Schließen",
    "fr": "Fermer",
    "es": "Cerrar"
  },
  "提及品牌数": {
    "en": "Mentioned Brands Count",
    "ja": "言及ブランド数",
    "de": "Anzahl erwähnter Marken",
    "fr": "Nombre de marques mentionnées",
    "es": "Número de marcas mencionadas"
  },
  "暂无探测记录": {
    "en": "No probe records",
    "ja": "プローブ記録なし",
    "de": "Keine Probe-Aufzeichnungen",
    "fr": "Aucun enregistrement de sonde",
    "es": "Sin registros de sonda"
  },
  "/api/v1/attribution/stats": {
    "en": "/api/v1/attribution/stats",
    "ja": "/api/v1/attribution/stats",
    "de": "/api/v1/attribution/stats",
    "fr": "/api/v1/attribution/stats",
    "es": "/api/v1/attribution/stats"
  },
  "/api/v1/attribution/scan": {
    "en": "/api/v1/attribution/scan",
    "ja": "/api/v1/attribution/scan",
    "de": "/api/v1/attribution/scan",
    "fr": "/api/v1/attribution/scan",
    "es": "/api/v1/attribution/scan"
  },
  "AI 渠道订单归因": {
    "en": "AI Channel Order Attribution",
    "ja": "AIチャネル注文帰属",
    "de": "AI-Kanal-Auftragszuordnung",
    "fr": "Attribution des commandes par canal AI",
    "es": "Atribución de pedidos por canal AI"
  },
  "🔍 扫描近 30 天订单": {
    "en": "🔍 Scan Orders (Last 30 Days)",
    "ja": "🔍 過去30日間の注文をスキャン",
    "de": "🔍 Aufträge der letzten 30 Tage scannen",
    "fr": "🔍 Analyser les commandes des 30 derniers jours",
    "es": "🔍 Escanear pedidos de los últimos 30 días"
  },
  "AI 渠道": {
    "en": "AI Channel",
    "ja": "AIチャネル",
    "de": "AI-Kanal",
    "fr": "Canal AI",
    "es": "Canal AI"
  },
  "订单数": {
    "en": "Order Count",
    "ja": "注文数",
    "de": "Auftragsanzahl",
    "fr": "Nombre de commandes",
    "es": "Número de pedidos"
  },
  "暂无 AI 渠道订单": {
    "en": "No AI channel orders",
    "ja": "AIチャネルの注文はありません",
    "de": "Keine KI-Kanalbestellungen",
    "fr": "Aucune commande de canal IA",
    "es": "Sin pedidos de canal IA"
  },
  "AI 渠道可见性追踪 — Share-of-Voice · 竞品情报 · 渠道归因": {
    "en": "AI Channel Visibility Tracking — Share-of-Voice · Competitive Intelligence · Channel Attribution",
    "ja": "AIチャネル可視性トラッキング — Share-of-Voice · 競合情報 · チャネルアトリビューション",
    "de": "KI-Kanal-Sichtbarkeitsverfolgung — Share-of-Voice · Wettbewerbsinformationen · Kanalzuordnung",
    "fr": "Suivi de visibilité des canaux IA — Share-of-Voice · Intelligence concurrentielle · Attribution des canaux",
    "es": "Seguimiento de visibilidad de canales IA — Share-of-Voice · Inteligencia competitiva · Atribución de canales"
  },
  "SoV 仪表盘": {
    "en": "SoV Dashboard",
    "ja": "SoVダッシュボード",
    "de": "SoV-Dashboard",
    "fr": "Tableau de bord SoV",
    "es": "Panel SoV"
  },
  "监测配置": {
    "en": "Monitoring Config",
    "ja": "監視設定",
    "de": "Überwachungskonfiguration",
    "fr": "Configuration de surveillance",
    "es": "Configuración de monitoreo"
  },
  "探测记录": {
    "en": "Detection Records",
    "ja": "検出記録",
    "de": "Erkennungsaufzeichnungen",
    "fr": "Enregistrements de détection",
    "es": "Registros de detección"
  },
  "渠道归因": {
    "en": "Channel Attribution",
    "ja": "チャネルアトリビューション",
    "de": "Kanalzuordnung",
    "fr": "Attribution des canaux",
    "es": "Atribución de canales"
  },
  "具体性": {
    "en": "Specificity",
    "ja": "具体性",
    "de": "Spezifität",
    "fr": "Spécificité",
    "es": "Especificidad"
  },
  "问题-方案": {
    "en": "Problem-Solution",
    "ja": "問題-解決策",
    "de": "Problem-Lösung",
    "fr": "Problème-Solution",
    "es": "Problema-Solución"
  },
  "对比要素": {
    "en": "Comparison Elements",
    "ja": "比較要素",
    "de": "Vergleichselemente",
    "fr": "Éléments de comparaison",
    "es": "Elementos de comparación"
  },
  "FAQ 覆盖": {
    "en": "FAQ Coverage",
    "ja": "FAQカバレッジ",
    "de": "FAQ-Abdeckung",
    "fr": "Couverture FAQ",
    "es": "Cobertura de FAQ"
  },
  "使用场景": {
    "en": "Use Cases",
    "ja": "使用シナリオ",
    "de": "Anwendungsfälle",
    "fr": "Cas d'utilisation",
    "es": "Casos de uso"
  },
  "信任要素": {
    "en": "Trust Elements",
    "ja": "信頼要素",
    "de": "Vertrauenselemente",
    "fr": "Éléments de confiance",
    "es": "Elementos de confianza"
  },
  "/api/v1/diagnose": {
    "en": "/api/v1/diagnose",
    "ja": "/api/v1/diagnose",
    "de": "/api/v1/diagnose",
    "fr": "/api/v1/diagnose",
    "es": "/api/v1/diagnose"
  },
  "重写完成，请到\"重写审核\"页查看": {
    "en": "Rewrite complete, go to \"Rewrite Review\" page to view",
    "ja": "書き換え完了。「書き換え審査」ページでご確認ください",
    "de": "Umschreibung abgeschlossen, gehen Sie zur Seite \"Umschreibungsprüfung\"",
    "fr": "Réécriture terminée, allez à la page \"Révision des réécritures\"",
    "es": "Reescritura completa, vaya a la página \"Revisión de reescritura\""
  },
  "🩺 诊断全店 PDP": {
    "en": "🩺 Diagnose All Store PDPs",
    "ja": "🩺 全店舗PDPを診断",
    "de": "🩺 Alle Store-PDPs diagnostizieren",
    "fr": "🩺 Diagnostiquer tous les PDP du magasin",
    "es": "🩺 Diagnosticar todos los PDP de la tienda"
  },
  "总分": {
    "en": "Total Score",
    "ja": "合計点",
    "de": "Gesamtpunktzahl",
    "fr": "Score total",
    "es": "Puntuación total"
  },
  "分项": {
    "en": "Sub-scores",
    "ja": "項目別スコア",
    "de": "Einzelbewertungen",
    "fr": "Sous-scores",
    "es": "Subpuntuaciones"
  },
  "✍️ 双优重写": {
    "en": "✍️ Dual-Optimized Rewrite",
    "ja": "✍️ 二重最適化書き換え",
    "de": "✍️ Dual-optimierte Umschreibung",
    "fr": "✍️ Réécriture doublement optimisée",
    "es": "✍️ Reescritura doblemente optimizada"
  },
  "暂无诊断 — 点击\"诊断全店 PDP\"": {
    "en": "No diagnosis yet — Click \"Diagnose All Store PDPs\"",
    "ja": "診断結果はまだありません — 「全店舗PDPを診断」をクリック",
    "de": "Noch keine Diagnose — Klicken Sie auf \"Alle Store-PDPs diagnostizieren\"",
    "fr": "Aucun diagnostic pour l'instant — Cliquez sur \"Diagnostiquer tous les PDP du magasin\"",
    "es": "Sin diagnóstico aún — Haga clic en \"Diagnosticar todos los PDP de la tienda\""
  },
  "/api/v1/rewrites": {
    "en": "/api/v1/rewrites",
    "ja": "/api/v1/rewrites",
    "de": "/api/v1/rewrites",
    "fr": "/api/v1/rewrites",
    "es": "/api/v1/rewrites"
  },
  "已回滚": {
    "en": "Rolled back",
    "ja": "ロールバック済み",
    "de": "Zurückgesetzt",
    "fr": "Annulé",
    "es": "Reversión realizada"
  },
  "↩ 回滚": {
    "en": "↩ Rollback",
    "ja": "↩ ロールバック",
    "de": "↩ Zurücksetzen",
    "fr": "↩ Annuler",
    "es": "↩ Revertir"
  },
  "BEFORE（原版）": {
    "en": "BEFORE (Original)",
    "ja": "BEFORE（オリジナル）",
    "de": "BEFORE (Original)",
    "fr": "BEFORE (Original)",
    "es": "BEFORE (Original)"
  },
  "(空)": {
    "en": "(Empty)",
    "ja": "(空)",
    "de": "(Leer)",
    "fr": "(Vide)",
    "es": "(Vacío)"
  },
  "AFTER（人类版）": {
    "en": "AFTER (Human Version)",
    "ja": "AFTER（人間版）",
    "de": "AFTER (Menschliche Version)",
    "fr": "AFTER (Version humaine)",
    "es": "AFTER (Versión humana)"
  },
  "AI 结构化版": {
    "en": "AI Structured Version",
    "ja": "AI構造化版",
    "de": "KI-strukturierte Version",
    "fr": "Version structurée par IA",
    "es": "Versión estructurada por IA"
  },
  "规格表": {
    "en": "Spec Sheet",
    "ja": "仕様表",
    "de": "Spezifikationstabelle",
    "fr": "Fiche technique",
    "es": "Hoja de especificaciones"
  },
  "声音分": {
    "en": "Voice Score",
    "ja": "ボイススコア",
    "de": "Voice-Score",
    "fr": "Score vocal",
    "es": "Puntuación de voz"
  },
  "合规标记": {
    "en": "Compliance Markers",
    "ja": "コンプライアンスマーカー",
    "de": "Compliance-Markierungen",
    "fr": "Marqueurs de conformité",
    "es": "Marcadores de cumplimiento"
  },
  "暂无重写记录": {
    "en": "No rewrite records",
    "ja": "書き換え記録はありません",
    "de": "Keine Umschreibungsaufzeichnungen",
    "fr": "Aucun enregistrement de réécriture",
    "es": "Sin registros de reescritura"
  },
  "/api/v1/voice": {
    "en": "/api/v1/voice",
    "ja": "/api/v1/voice",
    "de": "/api/v1/voice",
    "fr": "/api/v1/voice",
    "es": "/api/v1/voice"
  },
  "加载中...": {
    "en": "Loading...",
    "ja": "読み込み中...",
    "de": "Laden...",
    "fr": "Chargement...",
    "es": "Cargando..."
  },
  "品牌声音档案": {
    "en": "Brand Voice Profile",
    "ja": "ブランドボイスプロファイル",
    "de": "Markenstimmenprofil",
    "fr": "Profil de voix de marque",
    "es": "Perfil de voz de marca"
  },
  "口吻": {
    "en": "Tone",
    "ja": "トーン",
    "de": "Ton",
    "fr": "Ton",
    "es": "Tono"
  },
  "专业": {
    "en": "Professional",
    "ja": "プロフェッショナル",
    "de": "Professionell",
    "fr": "Professionnel",
    "es": "Profesional"
  },
  "正式": {
    "en": "Formal",
    "ja": "フォーマル",
    "de": "Formell",
    "fr": "Formel",
    "es": "Formal"
  },
  "轻松": {
    "en": "Casual",
    "ja": "カジュアル",
    "de": "Locker",
    "fr": "Décontracté",
    "es": "Informal"
  },
  "年轻活泼": {
    "en": "Youthful & Lively",
    "ja": "若々しく活発",
    "de": "Jung und lebendig",
    "fr": "Jeune et dynamique",
    "es": "Joven y animado"
  },
  "品牌专词（锁定不改写，逗号分隔）": {
    "en": "Brand-specific terms (locked, comma-separated)",
    "ja": "ブランド固有用語（ロック、カンマ区切り）",
    "de": "Markenspezifische Begriffe (gesperrt, durch Komma getrennt)",
    "fr": "Termes spécifiques à la marque (verrouillés, séparés par des virgules)",
    "es": "Términos específicos de la marca (bloqueados, separados por comas)"
  },
  "禁用词黑名单（逗号分隔）": {
    "en": "Blacklisted words (comma-separated)",
    "ja": "禁止ワードブラックリスト（カンマ区切り）",
    "de": "Blacklist-Wörter (durch Komma getrennt)",
    "fr": "Mots interdits (séparés par des virgules)",
    "es": "Palabras prohibidas (separadas por comas)"
  },
  "品牌口吻范例文本": {
    "en": "Brand Voice Sample Text",
    "ja": "ブランドトーンサンプルテキスト",
    "de": "Beispieltext für Markenton",
    "fr": "Exemple de texte de ton de marque",
    "es": "Texto de ejemplo de tono de marca"
  },
  "保存档案": {
    "en": "Save Archive",
    "ja": "アーカイブを保存",
    "de": "Archiv speichern",
    "fr": "Enregistrer l'archive",
    "es": "Guardar archivo"
  },
  "产品页 AI 可读性重写 — 6 维诊断 · 双优重写 · 品牌声音保护 · 一键回滚": {
    "en": "Product Page AI Readability Rewrite — 6-Dimension Diagnosis · Dual-Optimization Rewrite · Brand Voice Protection · One-Click Rollback",
    "ja": "商品ページAI可読性リライト — 6次元診断・二重最適化リライト・ブランドボイス保護・ワンクリックロールバック",
    "de": "KI-Überarbeitung der Lesbarkeit von Produktseiten — 6-dimensionale Diagnose · Dual-Optimierungs-Umschreibung · Schutz der Markenstimme · Ein-Klick-Rollback",
    "fr": "Réécriture de la lisibilité AI de la page produit — Diagnostic 6 dimensions · Réécriture double optimisation · Protection de la voix de marque · Retour en arrière en un clic",
    "es": "Reescritura de legibilidad AI de página de producto — Diagnóstico de 6 dimensiones · Reescritura de doble optimización · Protección de voz de marca · Reversión con un clic"
  },
  "就绪度诊断": {
    "en": "Readiness Diagnosis",
    "ja": "準備度診断",
    "de": "Bereitschaftsdiagnose",
    "fr": "Diagnostic de préparation",
    "es": "Diagnóstico de preparación"
  },
  "重写审核": {
    "en": "Rewrite Review",
    "ja": "リライトレビュー",
    "de": "Überarbeitungsprüfung",
    "fr": "Révision de réécriture",
    "es": "Revisión de reescritura"
  },
  "品牌声音": {
    "en": "Brand Voice",
    "ja": "ブランドボイス",
    "de": "Markenstimme",
    "fr": "Voix de marque",
    "es": "Voz de marca"
  },
  "待处理": {
    "en": "Pending",
    "ja": "保留中",
    "de": "Ausstehend",
    "fr": "En attente",
    "es": "Pendiente"
  },
  "✅ 自动批准": {
    "en": "✅ Auto Approved",
    "ja": "✅ 自動承認",
    "de": "✅ Automatisch genehmigt",
    "fr": "✅ Approuvé automatiquement",
    "es": "✅ Aprobado automáticamente"
  },
  "⚠️ 待补图": {
    "en": "⚠️ Image Needed",
    "ja": "⚠️ 画像追加待ち",
    "de": "⚠️ Bild erforderlich",
    "fr": "⚠️ Image requise",
    "es": "⚠️ Imagen pendiente"
  },
  "🔍 转人工": {
    "en": "🔍 Manual Review",
    "ja": "🔍 手動レビューへ",
    "de": "🔍 Manuelle Prüfung",
    "fr": "🔍 Révision manuelle",
    "es": "🔍 Revisión manual"
  },
  "❌ 已拒绝": {
    "en": "❌ Rejected",
    "ja": "❌ 拒否済み",
    "de": "❌ Abgelehnt",
    "fr": "❌ Refusé",
    "es": "❌ Rechazado"
  },
  "💰 已退款": {
    "en": "💰 Refunded",
    "ja": "💰 返金済み",
    "de": "💰 Rückerstattet",
    "fr": "💰 Remboursé",
    "es": "💰 Reembolsado"
  },
  "🔄 已换货": {
    "en": "🔄 Exchanged",
    "ja": "🔄 交換済み",
    "de": "🔄 Umtausch erfolgt",
    "fr": "🔄 Échangé",
    "es": "🔄 Cambiado"
  },
  "已关闭": {
    "en": "Closed",
    "ja": "クローズ",
    "de": "Geschlossen",
    "fr": "Fermé",
    "es": "Cerrado"
  },
  "/api/v1/dashboard/stats": {
    "en": "/api/v1/dashboard/stats",
    "ja": "/api/v1/dashboard/stats",
    "de": "/api/v1/dashboard/stats",
    "fr": "/api/v1/dashboard/stats",
    "es": "/api/v1/dashboard/stats"
  },
  "/api/v1/dashboard/reasons": {
    "en": "/api/v1/dashboard/reasons",
    "ja": "/api/v1/dashboard/reasons",
    "de": "/api/v1/dashboard/reasons",
    "fr": "/api/v1/dashboard/reasons",
    "es": "/api/v1/dashboard/reasons"
  },
  "30天退货单": {
    "en": "30-Day Return Orders",
    "ja": "30日間返品注文",
    "de": "30-Tage-Rücksendungen",
    "fr": "Commandes retournées sur 30 jours",
    "es": "Pedidos de devolución de 30 días"
  },
  "自动化率": {
    "en": "Automation Rate",
    "ja": "自動化率",
    "de": "Automatisierungsrate",
    "fr": "Taux d'automatisation",
    "es": "Tasa de automatización"
  },
  "无需人工介入的占比": {
    "en": "Percentage Without Manual Intervention",
    "ja": "手動介入不要の割合",
    "de": "Anteil ohne manuellen Eingriff",
    "fr": "Pourcentage sans intervention manuelle",
    "es": "Porcentaje sin intervención manual"
  },
  "欺诈拦截": {
    "en": "Fraud Blocked",
    "ja": "不正ブロック",
    "de": "Betrugsblockaden",
    "fr": "Fraude bloquée",
    "es": "Fraude bloqueado"
  },
  "已退款金额": {
    "en": "Refunded Amount",
    "ja": "返金額",
    "de": "Rückerstattungsbetrag",
    "fr": "Montant remboursé",
    "es": "Monto reembolsado"
  },
  "退货原因分布（90 天）": {
    "en": "Return Reason Distribution (90 Days)",
    "ja": "返品理由分布（90日間）",
    "de": "Verteilung der Rückgabegründe (90 Tage)",
    "fr": "Répartition des motifs de retour (90 jours)",
    "es": "Distribución de motivos de devolución (90 días)"
  },
  "原因": {
    "en": "Reason",
    "ja": "理由",
    "de": "Grund",
    "fr": "Motif",
    "es": "Motivo"
  },
  "数量": {
    "en": "Quantity",
    "ja": "数量",
    "de": "Menge",
    "fr": "Quantité",
    "es": "Cantidad"
  },
  "金额": {
    "en": "Amount",
    "ja": "金額",
    "de": "Betrag",
    "fr": "Montant",
    "es": "Monto"
  },
  "暂无数据": {
    "en": "No Data",
    "ja": "データなし",
    "de": "Keine Daten",
    "fr": "Aucune donnée",
    "es": "Sin datos"
  },
  "订单": {
    "en": "Order",
    "ja": "注文",
    "de": "Bestellung",
    "fr": "Commande",
    "es": "Pedido"
  },
  "客户": {
    "en": "Customer",
    "ja": "顧客",
    "de": "Kunde",
    "fr": "Client",
    "es": "Cliente"
  },
  "欺诈分": {
    "en": "Fraud Score",
    "ja": "不正スコア",
    "de": "Betrugsbewertung",
    "fr": "Score de fraude",
    "es": "Puntuación de fraude"
  },
  "批准": {
    "en": "Approve",
    "ja": "承認",
    "de": "Genehmigen",
    "fr": "Approuver",
    "es": "Aprobar"
  },
  "拒绝": {
    "en": "Reject",
    "ja": "拒否",
    "de": "Ablehnen",
    "fr": "Refuser",
    "es": "Rechazar"
  },
  "执行退款": {
    "en": "Execute Refund",
    "ja": "返金実行",
    "de": "Rückerstattung durchführen",
    "fr": "Exécuter le remboursement",
    "es": "Ejecutar reembolso"
  },
  "暂无退货申请": {
    "en": "No Return Requests",
    "ja": "返品リクエストなし",
    "de": "Keine Rückgabeanträge",
    "fr": "Aucune demande de retour",
    "es": "Sin solicitudes de devolución"
  },
  "/api/v1/fraud/profiles": {
    "en": "/api/v1/fraud/profiles",
    "ja": "/api/v1/fraud/profiles",
    "de": "/api/v1/fraud/profiles",
    "fr": "/api/v1/fraud/profiles",
    "es": "/api/v1/fraud/profiles"
  },
  "/api/v1/fraud/scan": {
    "en": "/api/v1/fraud/scan",
    "ja": "/api/v1/fraud/scan",
    "de": "/api/v1/fraud/scan",
    "fr": "/api/v1/fraud/scan",
    "es": "/api/v1/fraud/scan"
  },
  "客户风险档案": {
    "en": "Customer Risk Profile",
    "ja": "顧客リスクプロファイル",
    "de": "Kundenrisikoprofil",
    "fr": "Profil de risque client",
    "es": "Perfil de riesgo del cliente"
  },
  "🔄 重新扫描订单": {
    "en": "🔄 Rescan Orders",
    "ja": "🔄 注文を再スキャン",
    "de": "🔄 Bestellungen erneut scannen",
    "fr": "🔄 Rescanner les commandes",
    "es": "🔄 Volver a escanear pedidos"
  },
  "退货率": {
    "en": "Return Rate",
    "ja": "返品率",
    "de": "Rückgabequote",
    "fr": "Taux de retour",
    "es": "Tasa de devolución"
  },
  "风险分": {
    "en": "Risk Score",
    "ja": "リスクスコア",
    "de": "Risikobewertung",
    "fr": "Score de risque",
    "es": "Puntuación de riesgo"
  },
  "等级": {
    "en": "Level",
    "ja": "レベル",
    "de": "Stufe",
    "fr": "Niveau",
    "es": "Nivel"
  },
  "调整": {
    "en": "Adjust",
    "ja": "調整",
    "de": "Anpassen",
    "fr": "Ajuster",
    "es": "Ajustar"
  },
  "暂无档案 — 点击\"重新扫描订单\"生成": {
    "en": "No profile — click \"Rescan Orders\" to generate",
    "ja": "プロファイルなし — 「注文を再スキャン」をクリックして生成",
    "de": "Kein Profil — klicken Sie auf \"Aufträge erneut scannen\", um zu generieren",
    "fr": "Aucun profil — cliquez sur \"Analyser à nouveau les commandes\" pour générer",
    "es": "Sin perfil — haga clic en \"Volver a escanear pedidos\" para generar"
  },
  "/api/v1/policy": {
    "en": "/api/v1/policy",
    "ja": "/api/v1/policy",
    "de": "/api/v1/policy",
    "fr": "/api/v1/policy",
    "es": "/api/v1/policy"
  },
  "退货政策规则": {
    "en": "Return Policy Rules",
    "ja": "返品ポリシールール",
    "de": "Rückgaberichtlinien-Regeln",
    "fr": "Règles de politique de retour",
    "es": "Reglas de política de devolución"
  },
  "退货窗口（天）": {
    "en": "Return Window (days)",
    "ja": "返品期間（日）",
    "de": "Rückgabefrist (Tage)",
    "fr": "Délai de retour (jours)",
    "es": "Ventana de devolución (días)"
  },
  "最终销售标签（逗号分隔）": {
    "en": "Final Sale Tags (comma-separated)",
    "ja": "最終販売タグ（カンマ区切り）",
    "de": "Endverkaufs-Tags (kommagetrennt)",
    "fr": "Étiquettes de vente finale (séparées par des virgules)",
    "es": "Etiquetas de venta final (separadas por comas)"
  },
  "自动退款上限（$）": {
    "en": "Auto Refund Limit ($)",
    "ja": "自動返金上限（$）",
    "de": "Automatisches Rückerstattungslimit ($)",
    "fr": "Limite de remboursement automatique ($)",
    "es": "Límite de reembolso automático ($)"
  },
  "需照片证明的原因（逗号分隔）": {
    "en": "Reasons Requiring Photo Proof (comma-separated)",
    "ja": "写真証明が必要な理由（カンマ区切り）",
    "de": "Gründe, die einen Fotobeweis erfordern (kommagetrennt)",
    "fr": "Raisons nécessitant une preuve photo (séparées par des virgules)",
    "es": "Razones que requieren prueba fotográfica (separadas por comas)"
  },
  "欺诈转人工阈值（0-100）": {
    "en": "Fraud Escalation Threshold (0-100)",
    "ja": "不正エスカレーションしきい値（0-100）",
    "de": "Betrugs-Eskalationsschwelle (0-100)",
    "fr": "Seuil d'escalade de fraude (0-100)",
    "es": "Umbral de escalada de fraude (0-100)"
  },
  "欺诈拒绝阈值（0-100）": {
    "en": "Fraud Rejection Threshold (0-100)",
    "ja": "不正拒否しきい値（0-100）",
    "de": "Betrugs-Ablehnungsschwelle (0-100)",
    "fr": "Seuil de rejet de fraude (0-100)",
    "es": "Umbral de rechazo de fraude (0-100)"
  },
  "挽留方案 LTV 门槛（$）": {
    "en": "Retention Offer LTV Threshold ($)",
    "ja": "維持オファー LTV しきい値（$）",
    "de": "Bindungsangebot LTV-Schwelle ($)",
    "fr": "Seuil LTV de l'offre de rétention ($)",
    "es": "Umbral LTV de oferta de retención ($)"
  },
  "保存规则": {
    "en": "Save Rules",
    "ja": "ルールを保存",
    "de": "Regeln speichern",
    "fr": "Enregistrer les règles",
    "es": "Guardar reglas"
  },
  "AI 退货判责与欺诈筛查 — 自动判定 · Vision 核查 · 欺诈拦截": {
    "en": "AI Return Adjudication & Fraud Screening — Auto Decision · Vision Check · Fraud Block",
    "ja": "AI返品判定と不正スクリーニング — 自動判定 · Vision確認 · 不正ブロック",
    "de": "KI-Rückgabebeurteilung & Betrugsprüfung — Automatische Entscheidung · Vision-Prüfung · Betrugsblockade",
    "fr": "Adjudication des retours par IA & filtrage de fraude — Décision automatique · Vérification Vision · Blocage de fraude",
    "es": "Adjudicación de devoluciones por IA y detección de fraude — Decisión automática · Verificación Vision · Bloqueo de fraude"
  },
  "退货队列": {
    "en": "Return Queue",
    "ja": "返品キュー",
    "de": "Rückgabewarteschlange",
    "fr": "File d'attente des retours",
    "es": "Cola de devoluciones"
  },
  "洞察": {
    "en": "Insights",
    "ja": "インサイト",
    "de": "Einblicke",
    "fr": "Insights",
    "es": "Información"
  },
  "风险档案": {
    "en": "Risk Profile",
    "ja": "リスクプロファイル",
    "de": "Risikoprofil",
    "fr": "Profil de risque",
    "es": "Perfil de riesgo"
  },
  "政策设置": {
    "en": "Policy Settings",
    "ja": "ポリシー設定",
    "de": "Richtlinieneinstellungen",
    "fr": "Paramètres de politique",
    "es": "Configuración de políticas"
  },
  "/api/v1/replenish/models?limit=50": {
    "en": "/api/v1/replenish/models?limit=50",
    "ja": "/api/v1/replenish/models?limit=50",
    "de": "/api/v1/replenish/models?limit=50",
    "fr": "/api/v1/replenish/models?limit=50",
    "es": "/api/v1/replenish/models?limit=50"
  },
  "/api/v1/replenish/reminders": {
    "en": "/api/v1/replenish/reminders",
    "ja": "/api/v1/replenish/reminders",
    "de": "/api/v1/replenish/reminders",
    "fr": "/api/v1/replenish/reminders",
    "es": "/api/v1/replenish/reminders"
  },
  "/api/v1/replenish/analyze": {
    "en": "/api/v1/replenish/analyze",
    "ja": "/api/v1/replenish/analyze",
    "de": "/api/v1/replenish/analyze",
    "fr": "/api/v1/replenish/analyze",
    "es": "/api/v1/replenish/analyze"
  },
  "消耗周期模型（按到期排序）": {
    "en": "Consumption Cycle Models (sorted by expiry)",
    "ja": "消費サイクルモデル（期限順）",
    "de": "Verbrauchszyklusmodelle (sortiert nach Ablauf)",
    "fr": "Modèles de cycle de consommation (triés par expiration)",
    "es": "Modelos de ciclo de consumo (ordenados por vencimiento)"
  },
  "周期(天)": {
    "en": "Cycle (days)",
    "ja": "周期（日）",
    "de": "Zyklus (Tage)",
    "fr": "Cycle (jours)",
    "es": "Ciclo (días)"
  },
  "购买次数": {
    "en": "Purchase Count",
    "ja": "購入回数",
    "de": "Kaufanzahl",
    "fr": "Nombre d'achats",
    "es": "Número de compras"
  },
  "下次到期": {
    "en": "Next Expiry",
    "ja": "次回期限",
    "de": "Nächster Ablauf",
    "fr": "Prochaine expiration",
    "es": "Próximo vencimiento"
  },
  "置信度": {
    "en": "Confidence",
    "ja": "信頼度",
    "de": "Konfidenz",
    "fr": "Confiance",
    "es": "Confianza"
  },
  "暂无模型 — 点击\"分析订单建模\"": {
    "en": "No models — click \"Analyze Orders to Model\"",
    "ja": "モデルなし — 「注文を分析してモデル化」をクリック",
    "de": "Keine Modelle — klicken Sie auf \"Aufträge analysieren und modellieren\"",
    "fr": "Aucun modèle — cliquez sur \"Analyser les commandes pour modéliser\"",
    "es": "Sin modelos — haga clic en \"Analizar pedidos para modelar\""
  },
  "复购提醒队列": {
    "en": "Replenish Reminder Queue",
    "ja": "補充リマインダーキュー",
    "de": "Nachbestellungs-Erinnerungswarteschlange",
    "fr": "File d'attente des rappels de réapprovisionnement",
    "es": "Cola de recordatorios de reposición"
  },
  "计划时间": {
    "en": "Scheduled Time",
    "ja": "予定時間",
    "de": "Geplante Zeit",
    "fr": "Heure prévue",
    "es": "Hora programada"
  },
  "文案": {
    "en": "Copy",
    "ja": "コピー",
    "de": "Text",
    "fr": "Texte",
    "es": "Texto"
  },
  "暂无提醒": {
    "en": "No reminders",
    "ja": "リマインダーなし",
    "de": "Keine Erinnerungen",
    "fr": "Aucun rappel",
    "es": "Sin recordatorios"
  },
  "/api/v1/inventory/alerts?status=all": {
    "en": "/api/v1/inventory/alerts?status=all",
    "ja": "/api/v1/inventory/alerts?status=all",
    "de": "/api/v1/inventory/alerts?status=all",
    "fr": "/api/v1/inventory/alerts?status=all",
    "es": "/api/v1/inventory/alerts?status=all"
  },
  "补货数量？": {
    "en": "Restock Quantity?",
    "ja": "補充数量？",
    "de": "Nachbestellmenge?",
    "fr": "Quantité de réapprovisionnement ?",
    "es": "¿Cantidad de reposición?"
  },
  "库存预警": {
    "en": "Inventory Alerts",
    "ja": "在庫アラート",
    "de": "Bestandswarnungen",
    "fr": "Alertes de stock",
    "es": "Alertas de inventario"
  },
  "🔍 扫描库存水位": {
    "en": "🔍 Scan Stock Levels",
    "ja": "🔍 在庫レベルをスキャン",
    "de": "🔍 Lagerbestände scannen",
    "fr": "🔍 Analyser les niveaux de stock",
    "es": "🔍 Escanear niveles de stock"
  },
  "库存": {
    "en": "Stock",
    "ja": "在庫",
    "de": "Bestand",
    "fr": "Stock",
    "es": "Stock"
  },
  "日动销": {
    "en": "Daily Sales",
    "ja": "日次販売",
    "de": "Täglicher Verkauf",
    "fr": "Ventes quotidiennes",
    "es": "Ventas diarias"
  },
  "剩余天数": {
    "en": "Days Remaining",
    "ja": "残り日数",
    "de": "Verbleibende Tage",
    "fr": "Jours restants",
    "es": "Días restantes"
  },
  "发起询价": {
    "en": "Request Quote",
    "ja": "見積もり依頼",
    "de": "Angebot anfordern",
    "fr": "Demander un devis",
    "es": "Solicitar cotización"
  },
  "暂无预警 — 点击\"扫描库存水位\"": {
    "en": "No alerts — click \"Scan Stock Levels\"",
    "ja": "アラートなし — 「在庫レベルをスキャン」をクリック",
    "de": "Keine Warnungen — klicken Sie auf \"Lagerbestände scannen\"",
    "fr": "Aucune alerte — cliquez sur \"Analyser les niveaux de stock\"",
    "es": "Sin alertas — haga clic en \"Escanear niveles de stock\""
  },
  "/api/v1/suppliers": {
    "en": "/api/v1/suppliers",
    "ja": "/api/v1/suppliers",
    "de": "/api/v1/suppliers",
    "fr": "/api/v1/suppliers",
    "es": "/api/v1/suppliers"
  },
  "成本": {
    "en": "Cost",
    "ja": "コスト",
    "de": "Kosten",
    "fr": "Coût",
    "es": "Costo"
  },
  "毛利底线%": {
    "en": "Gross Margin Floor %",
    "ja": "粗利率下限%",
    "de": "Bruttomarge-Untergrenze %",
    "fr": "Marge brute plancher %",
    "es": "Margen bruto mínimo %"
  },
  "当前毛利": {
    "en": "Current Gross Margin",
    "ja": "現在の粗利",
    "de": "Aktuelle Bruttomarge",
    "fr": "Marge brute actuelle",
    "es": "Margen bruto actual"
  },
  "护栏价": {
    "en": "Guardrail Price",
    "ja": "ガードレール価格",
    "de": "Schutzpreis",
    "fr": "Prix de garde-fou",
    "es": "Precio de protección"
  },
  "策略": {
    "en": "Strategy",
    "ja": "戦略",
    "de": "Strategie",
    "fr": "Stratégie",
    "es": "Estrategia"
  },
  "模式": {
    "en": "Mode",
    "ja": "モード",
    "de": "Modus",
    "fr": "Mode",
    "es": "Modo"
  },
  "自动": {
    "en": "Auto",
    "ja": "自動",
    "de": "Auto",
    "fr": "Auto",
    "es": "Automático"
  },
  "建议": {
    "en": "Suggest",
    "ja": "提案",
    "de": "Vorschlag",
    "fr": "Suggestion",
    "es": "Sugerir"
  },
  "锁定": {
    "en": "Lock",
    "ja": "ロック",
    "de": "Sperren",
    "fr": "Verrouiller",
    "es": "Bloquear"
  },
  "暂无 SKU — 点击\"同步商品\"": {
    "en": "No SKU — Click \"Sync Products\"",
    "ja": "SKUなし — 「商品同期」をクリック",
    "de": "Keine SKU — Klicken Sie auf \"Produkte synchronisieren\"",
    "fr": "Aucun SKU — Cliquez sur \"Synchroniser les produits\"",
    "es": "Sin SKU — Haga clic en \"Sincronizar productos\""
  },
  "请填写名称与 URL": {
    "en": "Please fill in name and URL",
    "ja": "名前とURLを入力してください",
    "de": "Bitte Name und URL eingeben",
    "fr": "Veuillez saisir le nom et l'URL",
    "es": "Por favor, complete el nombre y la URL"
  },
  "/api/v1/competitors/capture": {
    "en": "/api/v1/competitors/capture",
    "ja": "/api/v1/competitors/capture",
    "de": "/api/v1/competitors/capture",
    "fr": "/api/v1/competitors/capture",
    "es": "/api/v1/competitors/capture"
  },
  "竞品名称": {
    "en": "Competitor Name",
    "ja": "競合名",
    "de": "Wettbewerbername",
    "fr": "Nom du concurrent",
    "es": "Nombre del competidor"
  },
  "商品页 URL": {
    "en": "Product Page URL",
    "ja": "商品ページURL",
    "de": "Produktseiten-URL",
    "fr": "URL de la page produit",
    "es": "URL de la página del producto"
  },
  "📡 抓取价格": {
    "en": "📡 Capture Price",
    "ja": "📡 価格取得",
    "de": "📡 Preis erfassen",
    "fr": "📡 Capturer le prix",
    "es": "📡 Capturar precio"
  },
  "最新价格": {
    "en": "Latest Price",
    "ja": "最新価格",
    "de": "Aktuellster Preis",
    "fr": "Dernier prix",
    "es": "Último precio"
  },
  "抓取时间": {
    "en": "Capture Time",
    "ja": "取得時間",
    "de": "Erfassungszeit",
    "fr": "Heure de capture",
    "es": "Hora de captura"
  },
  "暂无竞品配置": {
    "en": "No Competitor Config",
    "ja": "競合設定なし",
    "de": "Keine Wettbewerberkonfiguration",
    "fr": "Aucune configuration concurrente",
    "es": "Sin configuración de competidores"
  },
  "已拒绝": {
    "en": "Rejected",
    "ja": "拒否済み",
    "de": "Abgelehnt",
    "fr": "Rejeté",
    "es": "Rechazado"
  },
  "原价": {
    "en": "Original Price",
    "ja": "元の価格",
    "de": "Ursprünglicher Preis",
    "fr": "Prix d'origine",
    "es": "Precio original"
  },
  "新价": {
    "en": "New Price",
    "ja": "新しい価格",
    "de": "Neuer Preis",
    "fr": "Nouveau prix",
    "es": "Nuevo precio"
  },
  "调后毛利": {
    "en": "Adjusted Gross Margin",
    "ja": "調整後粗利",
    "de": "Angepasste Bruttomarge",
    "fr": "Marge brute ajustée",
    "es": "Margen bruto ajustado"
  },
  "触发原因": {
    "en": "Trigger Reason",
    "ja": "トリガー理由",
    "de": "Auslösegrund",
    "fr": "Raison du déclenchement",
    "es": "Motivo del disparo"
  },
  "执行": {
    "en": "Execute",
    "ja": "実行",
    "de": "Ausführen",
    "fr": "Exécuter",
    "es": "Ejecutar"
  },
  "/api/v1/elasticity": {
    "en": "/api/v1/elasticity",
    "ja": "/api/v1/elasticity",
    "de": "/api/v1/elasticity",
    "fr": "/api/v1/elasticity",
    "es": "/api/v1/elasticity"
  },
  "/api/v1/elasticity/estimate": {
    "en": "/api/v1/elasticity/estimate",
    "ja": "/api/v1/elasticity/estimate",
    "de": "/api/v1/elasticity/estimate",
    "fr": "/api/v1/elasticity/estimate",
    "es": "/api/v1/elasticity/estimate"
  },
  "模拟调价幅度 %（如 -10 表示降价 10%）：": {
    "en": "Simulated Price Change % (e.g., -10 means 10% decrease):",
    "ja": "シミュレーション価格変更率 %（例：-10は10%値下げ）：",
    "de": "Simulierter Preisänderungsprozentsatz % (z.B. -10 bedeutet 10% Senkung):",
    "fr": "Pourcentage de changement de prix simulé % (ex: -10 signifie baisse de 10%) :",
    "es": "Porcentaje de cambio de precio simulado % (ej. -10 significa reducción del 10%):"
  },
  "📈 估算价格弹性": {
    "en": "📈 Estimate Price Elasticity",
    "ja": "📈 価格弾力性の推定",
    "de": "📈 Preiselastizität schätzen",
    "fr": "📈 Estimer l'élasticité des prix",
    "es": "📈 Estimar elasticidad del precio"
  },
  "仿真结果：": {
    "en": "Simulation Results:",
    "ja": "シミュレーション結果：",
    "de": "Simulationsergebnisse:",
    "fr": "Résultats de la simulation :",
    "es": "Resultados de la simulación:"
  },
  "弹性系数 E": {
    "en": "Elasticity Coefficient E",
    "ja": "弾力性係数 E",
    "de": "Elastizitätskoeffizient E",
    "fr": "Coefficient d'élasticité E",
    "es": "Coeficiente de elasticidad E"
  },
  "最优区间": {
    "en": "Optimal Range",
    "ja": "最適範囲",
    "de": "Optimaler Bereich",
    "fr": "Plage optimale",
    "es": "Rango óptimo"
  },
  "数据点": {
    "en": "Data Points",
    "ja": "データポイント",
    "de": "Datenpunkte",
    "fr": "Points de données",
    "es": "Puntos de datos"
  },
  "仿真": {
    "en": "Simulation",
    "ja": "シミュレーション",
    "de": "Simulation",
    "fr": "Simulation",
    "es": "Simulación"
  },
  "暂无弹性数据 — 点击\"估算价格弹性\"": {
    "en": "No Elasticity Data — Click \"Estimate Price Elasticity\"",
    "ja": "弾力性データなし — 「価格弾力性の推定」をクリック",
    "de": "Keine Elastizitätsdaten — Klicken Sie auf \"Preiselastizität schätzen\"",
    "fr": "Aucune donnée d'élasticité — Cliquez sur \"Estimer l'élasticité des prix\"",
    "es": "Sin datos de elasticidad — Haga clic en \"Estimar elasticidad del precio\""
  },
  "毛利感知动态定价 — 竞品监控 · 策略引擎 · 毛利护栏 · 弹性分析": {
    "en": "Gross Margin Aware Dynamic Pricing — Competitor Monitoring · Strategy Engine · Margin Guardrails · Elasticity Analysis",
    "ja": "粗利認識動的価格設定 — 競合監視 · 戦略エンジン · 粗利ガードレール · 弾力性分析",
    "de": "Bruttomarge-bewusste dynamische Preisgestaltung — Wettbewerberüberwachung · Strategie-Engine · Margenschutz · Elastizitätsanalyse",
    "fr": "Tarification dynamique sensible à la marge brute — Surveillance des concurrents · Moteur de stratégie · Garde-fous de marge · Analyse d'élasticité",
    "es": "Fijación de precios dinámica consciente del margen bruto — Monitoreo de competidores · Motor de estrategia · Protecciones de margen · Análisis de elasticidad"
  },
  "定价规则": {
    "en": "Pricing Rules",
    "ja": "価格設定ルール",
    "de": "Preisregeln",
    "fr": "Règles de tarification",
    "es": "Reglas de precios"
  },
  "竞品监控": {
    "en": "Competitor Monitoring",
    "ja": "競合監視",
    "de": "Wettbewerberüberwachung",
    "fr": "Surveillance des concurrents",
    "es": "Monitoreo de competidores"
  },
  "调价队列": {
    "en": "Price Adjustment Queue",
    "ja": "価格調整キュー",
    "de": "Preisanpassungswarteschlange",
    "fr": "File d'attente d'ajustement des prix",
    "es": "Cola de ajuste de precios"
  },
  "弹性分析": {
    "en": "Elasticity Analysis",
    "ja": "弾力性分析",
    "de": "Elastizitätsanalyse",
    "fr": "Analyse d'élasticité",
    "es": "Análisis de elasticidad"
  },
  "/api/v1/vamp": {
    "en": "/api/v1/vamp",
    "ja": "/api/v1/vamp",
    "de": "/api/v1/vamp",
    "fr": "/api/v1/vamp",
    "es": "/api/v1/vamp"
  },
  "当月争议率": {
    "en": "Current Month Dispute Rate",
    "ja": "当月紛争率",
    "de": "Streitrate des aktuellen Monats",
    "fr": "Taux de litige du mois en cours",
    "es": "Tasa de disputa del mes actual"
  },
  "当月订单": {
    "en": "Current Month Orders",
    "ja": "当月注文",
    "de": "Bestellungen des aktuellen Monats",
    "fr": "Commandes du mois en cours",
    "es": "Pedidos del mes actual"
  },
  "当月争议": {
    "en": "Current Month Disputes",
    "ja": "当月紛争",
    "de": "Streitfälle des aktuellen Monats",
    "fr": "Litiges du mois en cours",
    "es": "Disputas del mes actual"
  },
  "胜诉 / 败诉": {
    "en": "Won / Lost",
    "ja": "勝訴 / 敗訴",
    "de": "Gewonnen / Verloren",
    "fr": "Gagné / Perdu",
    "es": "Ganado / Perdido"
  },
  "争议率历史（月度）": {
    "en": "Dispute Rate History (Monthly)",
    "ja": "紛争率履歴（月次）",
    "de": "Streitratenverlauf (monatlich)",
    "fr": "Historique du taux de litige (mensuel)",
    "es": "Historial de tasa de disputa (mensual)"
  },
  "月份": {
    "en": "Month",
    "ja": "月",
    "de": "Monat",
    "fr": "Mois",
    "es": "Mes"
  },
  "争议": {
    "en": "Disputes",
    "ja": "紛争",
    "de": "Streitfälle",
    "fr": "Litiges",
    "es": "Disputas"
  },
  "争议率": {
    "en": "Dispute Rate",
    "ja": "紛争率",
    "de": "Streitrate",
    "fr": "Taux de litige",
    "es": "Tasa de disputa"
  },
  "/api/v1/disputes": {
    "en": "/api/v1/disputes",
    "ja": "/api/v1/disputes",
    "de": "/api/v1/disputes",
    "fr": "/api/v1/disputes",
    "es": "/api/v1/disputes"
  },
  "订单 ID：": {
    "en": "Order ID:",
    "ja": "注文ID：",
    "de": "Bestell-ID:",
    "fr": "ID de commande :",
    "es": "ID de pedido:"
  },
  "拒付原因码（fraudulent / product_not_received / product_unacceptable / unrecognized / general）：": {
    "en": "Chargeback Reason Code (fraudulent / product_not_received / product_unacceptable / unrecognized / general):",
    "ja": "チャージバック理由コード（fraudulent / product_not_received / product_unacceptable / unrecognized / general）：",
    "de": "Chargeback-Grundcode (fraudulent / product_not_received / product_unacceptable / unrecognized / general):",
    "fr": "Code motif de contestation (fraudulent / product_not_received / product_unacceptable / unrecognized / general) :",
    "es": "Código de motivo de contracargo (fraudulent / product_not_received / product_unacceptable / unrecognized / general):"
  },
  "争议金额 $：": {
    "en": "Dispute Amount $:",
    "ja": "紛争金額 $：",
    "de": "Streitbetrag $:",
    "fr": "Montant du litige $ :",
    "es": "Monto de la disputa $:"
  },
  "＋ 登记拒付": {
    "en": "+ Register Chargeback",
    "ja": "＋ チャージバック登録",
    "de": "+ Chargeback registrieren",
    "fr": "+ Enregistrer un contestation",
    "es": "+ Registrar contracargo"
  },
  "组卷响应文档": {
    "en": "Case Response Documents",
    "ja": "ケース応答書類",
    "de": "Fallantwortdokumente",
    "fr": "Documents de réponse au dossier",
    "es": "Documentos de respuesta del caso"
  },
  "原因码": {
    "en": "Reason Code",
    "ja": "理由コード",
    "de": "Grundcode",
    "fr": "Code motif",
    "es": "Código de motivo"
  },
  "证据截止": {
    "en": "Evidence Deadline",
    "ja": "証拠提出期限",
    "de": "Beweisfrist",
    "fr": "Date limite de preuve",
    "es": "Fecha límite de evidencia"
  },
  "🗂 自动组卷": {
    "en": "🗂 Auto Case",
    "ja": "🗂 自動ケース作成",
    "de": "🗂 Automatische Fallerstellung",
    "fr": "🗂 Dossier automatique",
    "es": "🗂 Caso automático"
  },
  "查看文档": {
    "en": "View Documents",
    "ja": "書類を表示",
    "de": "Dokumente anzeigen",
    "fr": "Voir les documents",
    "es": "Ver documentos"
  },
  "标记已提交": {
    "en": "Mark as Submitted",
    "ja": "提出済みとしてマーク",
    "de": "Als eingereicht markieren",
    "fr": "Marquer comme soumis",
    "es": "Marcar como enviado"
  },
  "胜诉": {
    "en": "Won",
    "ja": "勝訴",
    "de": "Gewonnen",
    "fr": "Gagné",
    "es": "Ganado"
  },
  "败诉": {
    "en": "Lost",
    "ja": "敗訴",
    "de": "Verloren",
    "fr": "Perdu",
    "es": "Perdido"
  },
  "暂无争议记录": {
    "en": "No dispute records",
    "ja": "紛争記録はありません",
    "de": "Keine Streitfälle",
    "fr": "Aucun litige",
    "es": "Sin registros de disputas"
  },
  "/api/v1/risk/orders": {
    "en": "/api/v1/risk/orders",
    "ja": "/api/v1/risk/orders",
    "de": "/api/v1/risk/orders",
    "fr": "/api/v1/risk/orders",
    "es": "/api/v1/risk/orders"
  },
  "/api/v1/risk/scan-orders": {
    "en": "/api/v1/risk/scan-orders",
    "ja": "/api/v1/risk/scan-orders",
    "de": "/api/v1/risk/scan-orders",
    "fr": "/api/v1/risk/scan-orders",
    "es": "/api/v1/risk/scan-orders"
  },
  "高风险订单（预防性干预）": {
    "en": "High-Risk Orders (Preventive Intervention)",
    "ja": "高リスク注文（予防的介入）",
    "de": "Hochrisikobestellungen (präventiver Eingriff)",
    "fr": "Commandes à haut risque (intervention préventive)",
    "es": "Pedidos de alto riesgo (intervención preventiva)"
  },
  "🔍 扫描近 7 天订单": {
    "en": "🔍 Scan Orders (Last 7 Days)",
    "ja": "🔍 過去7日間の注文をスキャン",
    "de": "🔍 Bestellungen der letzten 7 Tage scannen",
    "fr": "🔍 Analyser les commandes des 7 derniers jours",
    "es": "🔍 Escanear pedidos de los últimos 7 días"
  },
  "信号": {
    "en": "Signal",
    "ja": "シグナル",
    "de": "Signal",
    "fr": "Signal",
    "es": "Señal"
  },
  "处理": {
    "en": "Action",
    "ja": "処理",
    "de": "Aktion",
    "fr": "Action",
    "es": "Acción"
  },
  "已验证": {
    "en": "Verified",
    "ja": "確認済み",
    "de": "Verifiziert",
    "fr": "Vérifié",
    "es": "Verificado"
  },
  "已审核": {
    "en": "Reviewed",
    "ja": "審査済み",
    "de": "Geprüft",
    "fr": "Examiné",
    "es": "Revisado"
  },
  "已取消订单": {
    "en": "Cancelled Orders",
    "ja": "キャンセル済み注文",
    "de": "Stornierte Bestellungen",
    "fr": "Commandes annulées",
    "es": "Pedidos cancelados"
  },
  "暂无高风险订单": {
    "en": "No high-risk orders",
    "ja": "高リスク注文はありません",
    "de": "Keine Hochrisikobestellungen",
    "fr": "Aucune commande à haut risque",
    "es": "Sin pedidos de alto riesgo"
  },
  "/api/v1/abuse/flags": {
    "en": "/api/v1/abuse/flags",
    "ja": "/api/v1/abuse/flags",
    "de": "/api/v1/abuse/flags",
    "fr": "/api/v1/abuse/flags",
    "es": "/api/v1/abuse/flags"
  },
  "/api/v1/abuse/customers": {
    "en": "/api/v1/abuse/customers",
    "ja": "/api/v1/abuse/customers",
    "de": "/api/v1/abuse/customers",
    "fr": "/api/v1/abuse/customers",
    "es": "/api/v1/abuse/customers"
  },
  "/api/v1/abuse/scan": {
    "en": "/api/v1/abuse/scan",
    "ja": "/api/v1/abuse/scan",
    "de": "/api/v1/abuse/scan",
    "fr": "/api/v1/abuse/scan",
    "es": "/api/v1/abuse/scan"
  },
  "🔄 扫描滥用行为": {
    "en": "🔄 Scan Abuse",
    "ja": "🔄 不正利用をスキャン",
    "de": "🔄 Missbrauch scannen",
    "fr": "🔄 Analyser les abus",
    "es": "🔄 Escanear abuso"
  },
  "滥用标记": {
    "en": "Abuse Flag",
    "ja": "不正利用フラグ",
    "de": "Missbrauchsmarkierung",
    "fr": "Signalement d'abus",
    "es": "Marca de abuso"
  },
  "类型": {
    "en": "Type",
    "ja": "タイプ",
    "de": "Typ",
    "fr": "Type",
    "es": "Tipo"
  },
  "严重度": {
    "en": "Severity",
    "ja": "重大度",
    "de": "Schweregrad",
    "fr": "Gravité",
    "es": "Gravedad"
  },
  "解除": {
    "en": "Dismiss",
    "ja": "解除",
    "de": "Entfernen",
    "fr": "Supprimer",
    "es": "Descartar"
  },
  "暂无滥用标记": {
    "en": "No abuse flags",
    "ja": "不正利用フラグなし",
    "de": "Keine Missbrauchsmarkierungen",
    "fr": "Aucun signalement d'abus",
    "es": "Sin marcas de abuso"
  },
  "客户风险分层": {
    "en": "Customer risk tiering",
    "ja": "顧客リスク階層化",
    "de": "Kundenrisikostufung",
    "fr": "Hiérarchisation des risques clients",
    "es": "Segmentación de riesgo del cliente"
  },
  "因素": {
    "en": "Factors",
    "ja": "要因",
    "de": "Faktoren",
    "fr": "Facteurs",
    "es": "Factores"
  },
  "暂无评级数据 — 点击\"扫描滥用行为\"": {
    "en": "No rating data — Click \"Scan for abuse\"",
    "ja": "評価データなし — 「不正利用をスキャン」をクリック",
    "de": "Keine Bewertungsdaten — Klicken Sie auf \"Missbrauch scannen\"",
    "fr": "Aucune donnée d'évaluation — Cliquez sur \"Analyser les abus\"",
    "es": "Sin datos de calificación — Haga clic en \"Escanear abusos\""
  },
  "拒付防御与售后风控 — VAMP 监控 · 自动组卷 · 滥用侦测 · 风险分层": {
    "en": "Chargeback defense & post-sale risk control — VAMP monitoring · Auto case assembly · Abuse detection · Risk tiering",
    "ja": "チャージバック防御とアフターサービスリスク管理 — VAMP監視・自動ケース作成・不正利用検出・リスク階層化",
    "de": "Chargeback-Abwehr & After-Sales-Risikomanagement — VAMP-Überwachung · Automatische Fallerstellung · Missbrauchserkennung · Risikostufung",
    "fr": "Défense des contestations de paiement & contrôle des risques après-vente — Surveillance VAMP · Constitution automatique de dossiers · Détection des abus · Hiérarchisation des risques",
    "es": "Defensa de contracargos y control de riesgos postventa — Monitoreo VAMP · Armado automático de casos · Detección de abusos · Segmentación de riesgos"
  },
  "VAMP 合规": {
    "en": "VAMP Compliance",
    "ja": "VAMPコンプライアンス",
    "de": "VAMP-Compliance",
    "fr": "Conformité VAMP",
    "es": "Cumplimiento VAMP"
  },
  "拒付争议": {
    "en": "Chargeback disputes",
    "ja": "チャージバック異議申立",
    "de": "Chargeback-Streitfälle",
    "fr": "Contestations de paiement",
    "es": "Controversias de contracargos"
  },
  "风险订单": {
    "en": "Risk orders",
    "ja": "リスク注文",
    "de": "Risikobestellungen",
    "fr": "Commandes à risque",
    "es": "Pedidos de riesgo"
  },
  "售后滥用": {
    "en": "Post-sale abuse",
    "ja": "アフターサービス不正利用",
    "de": "After-Sales-Missbrauch",
    "fr": "Abus après-vente",
    "es": "Abuso postventa"
  },
  "德国": {
    "en": "Germany",
    "ja": "ドイツ",
    "de": "Deutschland",
    "fr": "Allemagne",
    "es": "Alemania"
  },
  "法国": {
    "en": "France",
    "ja": "フランス",
    "de": "Frankreich",
    "fr": "France",
    "es": "Francia"
  },
  "日本": {
    "en": "Japan",
    "ja": "日本",
    "de": "Japan",
    "fr": "Japon",
    "es": "Japón"
  },
  "韩国": {
    "en": "South Korea",
    "ja": "韓国",
    "de": "Südkorea",
    "fr": "Corée du Sud",
    "es": "Corea del Sur"
  },
  "西班牙": {
    "en": "Spain",
    "ja": "スペイン",
    "de": "Spanien",
    "fr": "Espagne",
    "es": "España"
  },
  "意大利": {
    "en": "Italy",
    "ja": "イタリア",
    "de": "Italien",
    "fr": "Italie",
    "es": "Italia"
  },
  "/api/v1/markets": {
    "en": "/api/v1/markets",
    "ja": "/api/v1/markets",
    "de": "/api/v1/markets",
    "fr": "/api/v1/markets",
    "es": "/api/v1/markets"
  },
  "/api/v1/glossary": {
    "en": "/api/v1/glossary",
    "ja": "/api/v1/glossary",
    "de": "/api/v1/glossary",
    "fr": "/api/v1/glossary",
    "es": "/api/v1/glossary"
  },
  "请填写术语": {
    "en": "Please fill in the term",
    "ja": "用語を入力してください",
    "de": "Bitte geben Sie den Begriff ein",
    "fr": "Veuillez saisir le terme",
    "es": "Por favor, complete el término"
  },
  "＋ 添加市场": {
    "en": "+ Add market",
    "ja": "+ 市場を追加",
    "de": "+ Markt hinzufügen",
    "fr": "+ Ajouter un marché",
    "es": "+ Añadir mercado"
  },
  "语言": {
    "en": "Language",
    "ja": "言語",
    "de": "Sprache",
    "fr": "Langue",
    "es": "Idioma"
  },
  "市场": {
    "en": "Market",
    "ja": "市場",
    "de": "Markt",
    "fr": "Marché",
    "es": "Mercado"
  },
  "货币": {
    "en": "Currency",
    "ja": "通貨",
    "de": "Währung",
    "fr": "Devise",
    "es": "Moneda"
  },
  "单位制": {
    "en": "Unit system",
    "ja": "単位系",
    "de": "Einheitensystem",
    "fr": "Système d'unités",
    "es": "Sistema de unidades"
  },
  "术语库（品牌专词留空翻译 = 保持原文）": {
    "en": "Glossary (leave brand-specific terms empty to keep original)",
    "ja": "用語集（ブランド固有の用語は空白のままにすると原文を保持）",
    "de": "Glossar (markenspezifische Begriffe leer lassen = Original beibehalten)",
    "fr": "Glossaire (laisser vide les termes de marque pour conserver l'original)",
    "es": "Glosario (dejar vacío los términos de marca para mantener el original)"
  },
  "术语/品牌词": {
    "en": "Terms/Brand words",
    "ja": "用語/ブランド語",
    "de": "Begriffe/Markenwörter",
    "fr": "Termes/Mots de marque",
    "es": "Términos/Palabras de marca"
  },
  "全部语言": {
    "en": "All languages",
    "ja": "全言語",
    "de": "Alle Sprachen",
    "fr": "Toutes les langues",
    "es": "Todos los idiomas"
  },
  "固定译法（留空=不翻译）": {
    "en": "Fixed translation (leave empty = do not translate)",
    "ja": "固定訳（空白=翻訳しない）",
    "de": "Feste Übersetzung (leer lassen = nicht übersetzen)",
    "fr": "Traduction fixe (laisser vide = ne pas traduire)",
    "es": "Traducción fija (dejar vacío = no traducir)"
  },
  "🔒 保持原文": {
    "en": "🔒 Keep original",
    "ja": "🔒 原文を保持",
    "de": "🔒 Original beibehalten",
    "fr": "🔒 Conserver l'original",
    "es": "🔒 Mantener original"
  },
  "/api/v1/localizations": {
    "en": "/api/v1/localizations",
    "ja": "/api/v1/localizations",
    "de": "/api/v1/localizations",
    "fr": "/api/v1/localizations",
    "es": "/api/v1/localizations"
  },
  "请先在\"市场配置\"添加目标市场": {
    "en": "Please add target markets in \"Market Configuration\" first",
    "ja": "先に「市場設定」でターゲット市場を追加してください",
    "de": "Bitte fügen Sie zuerst in der \"Marktkonfiguration\" Zielmärkte hinzu",
    "fr": "Veuillez d'abord ajouter des marchés cibles dans \"Configuration du marché\"",
    "es": "Primero agregue mercados objetivo en \"Configuración de mercado\""
  },
  "/api/v1/consistency/check": {
    "en": "/api/v1/consistency/check",
    "ja": "/api/v1/consistency/check",
    "de": "/api/v1/consistency/check",
    "fr": "/api/v1/consistency/check",
    "es": "/api/v1/consistency/check"
  },
  "已回写 Shopify Translations": {
    "en": "Written back to Shopify Translations",
    "ja": "Shopify翻訳に書き戻しました",
    "de": "Zurück in Shopify-Übersetzungen geschrieben",
    "fr": "Réécrit dans les traductions Shopify",
    "es": "Reescrito en Traducciones de Shopify"
  },
  "🌍 本地化产品（10个/批）": {
    "en": "🌍 Localize products (10 per batch)",
    "ja": "🌍 製品をローカライズ（1バッチ10件）",
    "de": "🌍 Produkte lokalisieren (10 pro Charge)",
    "fr": "🌍 Localiser les produits (10 par lot)",
    "es": "🌍 Localizar productos (10 por lote)"
  },
  "🔄 一致性检查": {
    "en": "🔄 Consistency check",
    "ja": "🔄 一貫性チェック",
    "de": "🔄 Konsistenzprüfung",
    "fr": "🔄 Vérification de cohérence",
    "es": "🔄 Verificación de consistencia"
  },
  "源文本": {
    "en": "Source text",
    "ja": "原文",
    "de": "Quelltext",
    "fr": "Texte source",
    "es": "Texto original"
  },
  "资源": {
    "en": "Resource",
    "ja": "リソース",
    "de": "Ressource",
    "fr": "Ressource",
    "es": "Recurso"
  },
  "适配说明": {
    "en": "Adaptation notes",
    "ja": "適応ノート",
    "de": "Anpassungshinweise",
    "fr": "Notes d'adaptation",
    "es": "Notas de adaptación"
  },
  "暂无本地化记录": {
    "en": "No localization records",
    "ja": "ローカライズ記録なし",
    "de": "Keine Lokalisierungsdatensätze",
    "fr": "Aucun enregistrement de localisation",
    "es": "Sin registros de localización"
  },
  "请粘贴政策文本": {
    "en": "Please paste the policy text",
    "ja": "ポリシーテキストを貼り付けてください",
    "de": "Bitte fügen Sie den Richtlinientext ein",
    "fr": "Veuillez coller le texte de la politique",
    "es": "Pegue el texto de la política"
  },
  "政策本地化（自动适配当地消费者保护法）": {
    "en": "Policy localization (auto-adapt to local consumer protection laws)",
    "ja": "ポリシーのローカライズ（現地の消費者保護法に自動適応）",
    "de": "Richtlinienlokalisierung (automatische Anpassung an lokale Verbraucherschutzgesetze)",
    "fr": "Localisation des politiques (adaptation automatique aux lois locales sur la protection des consommateurs)",
    "es": "Localización de políticas (adaptación automática a las leyes locales de protección al consumidor)"
  },
  "🌍 本地化政策": {
    "en": "Localization Policy",
    "ja": "ローカライゼーションポリシー",
    "de": "Lokalisierungsrichtlinie",
    "fr": "Politique de localisation",
    "es": "Política de localización"
  },
  "粘贴退换货/配送政策原文...": {
    "en": "Paste return/exchange/delivery policy text...",
    "ja": "返品・交換・配送ポリシーの原文を貼り付け...",
    "de": "Originaltext der Rückgabe-/Umtausch-/Versandrichtlinie einfügen...",
    "fr": "Collez le texte original de la politique de retour/échange/livraison...",
    "es": "Pegue el texto original de la política de devolución/cambio/envío..."
  },
  "跨境本地化 Agent — 文化适配翻译 · 单位换算 · 法规适配 · 一致性管理": {
    "en": "Cross-border Localization Agent — Cultural Adaptation Translation · Unit Conversion · Regulatory Compliance · Consistency Management",
    "ja": "越境ローカライゼーションエージェント — 文化適応翻訳 · 単位換算 · 規制適合 · 一貫性管理",
    "de": "Grenzüberschreitender Lokalisierungsagent — Kulturell angepasste Übersetzung · Einheitenumrechnung · Rechtskonformität · Konsistenzmanagement",
    "fr": "Agent de localisation transfrontalière — Traduction d'adaptation culturelle · Conversion d'unités · Conformité réglementaire · Gestion de la cohérence",
    "es": "Agente de localización transfronteriza — Traducción de adaptación cultural · Conversión de unidades · Cumplimiento normativo · Gestión de consistencia"
  },
  "产品本地化": {
    "en": "Product Localization",
    "ja": "製品ローカライゼーション",
    "de": "Produktlokalisierung",
    "fr": "Localisation de produit",
    "es": "Localización de producto"
  },
  "政策本地化": {
    "en": "Policy Localization",
    "ja": "ポリシーローカライゼーション",
    "de": "Richtlinienlokalisierung",
    "fr": "Localisation de politique",
    "es": "Localización de políticas"
  },
  "市场与术语库": {
    "en": "Market & Term Base",
    "ja": "市場と用語ベース",
    "de": "Markt- und Terminologiedatenbank",
    "fr": "Marché et base terminologique",
    "es": "Mercado y base de términos"
  },
  "✅ 通过": {
    "en": "✅ Pass",
    "ja": "✅ 合格",
    "de": "✅ Bestanden",
    "fr": "✅ Réussi",
    "es": "✅ Aprobado"
  },
  "⚠️ 警告": {
    "en": "⚠️ Warning",
    "ja": "⚠️ 警告",
    "de": "⚠️ Warnung",
    "fr": "⚠️ Avertissement",
    "es": "⚠️ Advertencia"
  },
  "🚫 拦截": {
    "en": "🚫 Blocked",
    "ja": "🚫 ブロック",
    "de": "🚫 Blockiert",
    "fr": "🚫 Bloqué",
    "es": "🚫 Bloqueado"
  },
  "请粘贴内容": {
    "en": "Please paste content",
    "ja": "内容を貼り付けてください",
    "de": "Bitte Inhalt einfügen",
    "fr": "Veuillez coller le contenu",
    "es": "Por favor pegue el contenido"
  },
  "上线前合规检测（PDP 描述 / 广告创意 / 博客）": {
    "en": "Pre-launch Compliance Check (PDP Description / Ad Creative / Blog)",
    "ja": "公開前コンプライアンスチェック（PDP説明 / 広告クリエイティブ / ブログ）",
    "de": "Compliance-Prüfung vor dem Start (PDP-Beschreibung / Werbemittel / Blog)",
    "fr": "Vérification de conformité avant lancement (Description PDP / Création publicitaire / Blog)",
    "es": "Verificación de cumplimiento previa al lanzamiento (Descripción PDP / Creativo publicitario / Blog)"
  },
  "通用": {
    "en": "General",
    "ja": "一般",
    "de": "Allgemein",
    "fr": "Général",
    "es": "General"
  },
  "保健品": {
    "en": "Health Supplements",
    "ja": "健康補助食品",
    "de": "Nahrungsergänzungsmittel",
    "fr": "Compléments de santé",
    "es": "Suplementos de salud"
  },
  "医疗护理": {
    "en": "Medical Care",
    "ja": "医療ケア",
    "de": "Medizinische Versorgung",
    "fr": "Soins médicaux",
    "es": "Cuidado médico"
  },
  "美妆": {
    "en": "Cosmetics",
    "ja": "化粧品",
    "de": "Kosmetik",
    "fr": "Cosmétiques",
    "es": "Cosméticos"
  },
  "金融": {
    "en": "Finance",
    "ja": "金融",
    "de": "Finanzen",
    "fr": "Finance",
    "es": "Finanzas"
  },
  "🛡️ 扫描内容": {
    "en": "🛡️ Scan Content",
    "ja": "🛡️ コンテンツをスキャン",
    "de": "🛡️ Inhalt scannen",
    "fr": "🛡️ Scanner le contenu",
    "es": "🛡️ Escanear contenido"
  },
  "粘贴待检测内容...": {
    "en": "Paste content to check...",
    "ja": "チェックする内容を貼り付け...",
    "de": "Zu prüfenden Inhalt einfügen...",
    "fr": "Collez le contenu à vérifier...",
    "es": "Pegue el contenido a verificar..."
  },
  " — 建议修改后再发布": {
    "en": " — Suggest editing before publishing",
    "ja": " — 公開前に修正を推奨",
    "de": " — Empfehlung: Vor Veröffentlichung bearbeiten",
    "fr": " — Suggérer une modification avant publication",
    "es": " — Sugerir editar antes de publicar"
  },
  "警告": {
    "en": "Warning",
    "ja": "警告",
    "de": "Warnung",
    "fr": "Avertissement",
    "es": "Advertencia"
  },
  "AI 语义识别": {
    "en": "AI Semantic Recognition",
    "ja": "AI意味認識",
    "de": "KI-Semantikerfassung",
    "fr": "Reconnaissance sémantique IA",
    "es": "Reconocimiento semántico de IA"
  },
  "未发现违规内容": {
    "en": "No violations found",
    "ja": "違反内容は見つかりませんでした",
    "de": "Keine Verstöße gefunden",
    "fr": "Aucune infraction trouvée",
    "es": "No se encontraron infracciones"
  },
  "/api/v1/scans": {
    "en": "/api/v1/scans",
    "ja": "/api/v1/scans",
    "de": "/api/v1/scans",
    "fr": "/api/v1/scans",
    "es": "/api/v1/scans"
  },
  "扫描记录": {
    "en": "Scan Records",
    "ja": "スキャン記録",
    "de": "Scan-Aufzeichnungen",
    "fr": "Historique des scans",
    "es": "Registros de escaneo"
  },
  "🔍 全店 PDP 扫描": {
    "en": "🔍 Full Store PDP Scan",
    "ja": "🔍 全店舗PDPスキャン",
    "de": "🔍 Vollständiger Shop-PDP-Scan",
    "fr": "🔍 Scan PDP de toute la boutique",
    "es": "🔍 Escaneo PDP de toda la tienda"
  },
  "内容": {
    "en": "Content",
    "ja": "内容",
    "de": "Inhalt",
    "fr": "Contenu",
    "es": "Contenido"
  },
  "结果": {
    "en": "Result",
    "ja": "結果",
    "de": "Ergebnis",
    "fr": "Résultat",
    "es": "Resultado"
  },
  "问题数": {
    "en": "Issues",
    "ja": "問題数",
    "de": "Probleme",
    "fr": "Problèmes",
    "es": "Problemas"
  },
  "暂无扫描记录": {
    "en": "No scan records yet",
    "ja": "スキャン記録はまだありません",
    "de": "Noch keine Scan-Aufzeichnungen",
    "fr": "Aucun historique de scan pour le moment",
    "es": "Aún no hay registros de escaneo"
  },
  "/api/v1/terms": {
    "en": "/api/v1/terms",
    "ja": "/api/v1/terms",
    "de": "/api/v1/terms",
    "fr": "/api/v1/terms",
    "es": "/api/v1/terms"
  },
  "请填写词条": {
    "en": "Please fill in the term",
    "ja": "用語を入力してください",
    "de": "Bitte Begriff eingeben",
    "fr": "Veuillez saisir le terme",
    "es": "Por favor complete el término"
  },
  "违禁词": {
    "en": "Prohibited Words",
    "ja": "禁止用語",
    "de": "Verbotene Wörter",
    "fr": "Mots interdits",
    "es": "Palabras prohibidas"
  },
  "医疗": {
    "en": "Medical",
    "ja": "医療",
    "de": "Medizinisch",
    "fr": "Médical",
    "es": "Médico"
  },
  "拦截": {
    "en": "Block",
    "ja": "ブロック",
    "de": "Blockieren",
    "fr": "Bloquer",
    "es": "Bloquear"
  },
  "合规替代措辞": {
    "en": "Compliant Alternative Wording",
    "ja": "コンプライアンス代替表現",
    "de": "Konforme Alternativformulierung",
    "fr": "Formulation alternative conforme",
    "es": "Redacción alternativa conforme"
  },
  "词条": {
    "en": "Term",
    "ja": "用語",
    "de": "Begriff",
    "fr": "Terme",
    "es": "Término"
  },
  "类目": {
    "en": "Category",
    "ja": "カテゴリ",
    "de": "Kategorie",
    "fr": "Catégorie",
    "es": "Categoría"
  },
  "平台": {
    "en": "Platform",
    "ja": "プラットフォーム",
    "de": "Plattform",
    "fr": "Plateforme",
    "es": "Plataforma"
  },
  "级别": {
    "en": "Level",
    "ja": "レベル",
    "de": "Stufe",
    "fr": "Niveau",
    "es": "Nivel"
  },
  "替代措辞": {
    "en": "Alternative Wording",
    "ja": "代替表現",
    "de": "Alternativformulierung",
    "fr": "Formulation alternative",
    "es": "Redacción alternativa"
  },
  "来源": {
    "en": "Source",
    "ja": "ソース",
    "de": "Quelle",
    "fr": "Source",
    "es": "Fuente"
  },
  "自定义": {
    "en": "Custom",
    "ja": "カスタム",
    "de": "Benutzerdefiniert",
    "fr": "Personnalisé",
    "es": "Personalizado"
  },
  "合规违禁内容守卫 — 违禁词库 · 语义扫描 · 上线前拦截": {
    "en": "Compliance Guard - Prohibited Words · Semantic Scan · Pre-launch Block",
    "ja": "コンプライアンスガード - 禁止ワード · セマンティックスキャン · 公開前ブロック",
    "de": "Compliance-Guard - Verbotene Wörter · Semantischer Scan · Pre-Launch-Block",
    "fr": "Garde de conformité - Mots interdits · Scan sémantique · Blocage avant lancement",
    "es": "Guardia de cumplimiento - Palabras prohibidas · Escaneo semántico · Bloqueo previo al lanzamiento"
  },
  "即时检测": {
    "en": "Instant Check",
    "ja": "即時チェック",
    "de": "Sofortprüfung",
    "fr": "Vérification instantanée",
    "es": "Verificación instantánea"
  },
  "全店扫描": {
    "en": "Full Store Scan",
    "ja": "全店スキャン",
    "de": "Vollständiger Shop-Scan",
    "fr": "Scan complet de la boutique",
    "es": "Escaneo completo de la tienda"
  },
  "违禁词库": {
    "en": "Prohibited Words Library",
    "ja": "禁止ワードライブラリ",
    "de": "Bibliothek verbotener Wörter",
    "fr": "Bibliothèque de mots interdits",
    "es": "Biblioteca de palabras prohibidas"
  },
  "首轮报价": {
    "en": "Initial Offer",
    "ja": "初回オファー",
    "de": "Erstangebot",
    "fr": "Première offre",
    "es": "Oferta inicial"
  },
  "还价中": {
    "en": "Countering",
    "ja": "交渉中",
    "de": "Gegenangebot läuft",
    "fr": "En contre-offre",
    "es": "Contraoferta en curso"
  },
  "让步阶段": {
    "en": "Concession Stage",
    "ja": "譲歩段階",
    "de": "Zugeständnisphase",
    "fr": "Phase de concession",
    "es": "Etapa de concesión"
  },
  "最终报价": {
    "en": "Final Offer",
    "ja": "最終オファー",
    "de": "Letztes Angebot",
    "fr": "Offre finale",
    "es": "Oferta final"
  },
  "✅ 成交": {
    "en": "✅ Deal",
    "ja": "✅ 成立",
    "de": "✅ Abschluss",
    "fr": "✅ Conclu",
    "es": "✅ Acuerdo"
  },
  "❌ 流失": {
    "en": "❌ Lost",
    "ja": "❌ 流失",
    "de": "❌ Verloren",
    "fr": "❌ Perdu",
    "es": "❌ Perdido"
  },
  "/api/v1/inquiries": {
    "en": "/api/v1/inquiries",
    "ja": "/api/v1/inquiries",
    "de": "/api/v1/inquiries",
    "fr": "/api/v1/inquiries",
    "es": "/api/v1/inquiries"
  },
  "请粘贴询盘邮件": {
    "en": "Paste inquiry email",
    "ja": "問い合わせメールを貼り付け",
    "de": "Anfrage-E-Mail einfügen",
    "fr": "Collez l'email de demande",
    "es": "Pegue el correo de consulta"
  },
  "新询盘解析": {
    "en": "New Inquiry Analysis",
    "ja": "新規問い合わせ解析",
    "de": "Neue Anfrageanalyse",
    "fr": "Analyse de nouvelle demande",
    "es": "Análisis de nueva consulta"
  },
  "粘贴买家询盘邮件原文...": {
    "en": "Paste buyer inquiry email...",
    "ja": "買い手の問い合わせメール原文を貼り付け...",
    "de": "E-Mail der Käuferanfrage einfügen...",
    "fr": "Collez l'email original de la demande de l'acheteur...",
    "es": "Pegue el correo original de la consulta del comprador..."
  },
  "🤖 解析询盘": {
    "en": "🤖 Analyze Inquiry",
    "ja": "🤖 問い合わせ解析",
    "de": "🤖 Anfrage analysieren",
    "fr": "🤖 Analyser la demande",
    "es": "🤖 Analizar consulta"
  },
  "买家": {
    "en": "Buyer",
    "ja": "買い手",
    "de": "Käufer",
    "fr": "Acheteur",
    "es": "Comprador"
  },
  "意图": {
    "en": "Intent",
    "ja": "意図",
    "de": "Absicht",
    "fr": "Intention",
    "es": "Intención"
  },
  "需求摘要": {
    "en": "Requirement Summary",
    "ja": "要件概要",
    "de": "Anforderungszusammenfassung",
    "fr": "Résumé des besoins",
    "es": "Resumen de requisitos"
  },
  "开启谈判": {
    "en": "Start Negotiation",
    "ja": "交渉開始",
    "de": "Verhandlung starten",
    "fr": "Démarrer la négociation",
    "es": "Iniciar negociación"
  },
  "暂无询盘": {
    "en": "No inquiries yet",
    "ja": "問い合わせはまだありません",
    "de": "Noch keine Anfragen",
    "fr": "Aucune demande pour l'instant",
    "es": "Aún no hay consultas"
  },
  "/api/v1/negotiations": {
    "en": "/api/v1/negotiations",
    "ja": "/api/v1/negotiations",
    "de": "/api/v1/negotiations",
    "fr": "/api/v1/negotiations",
    "es": "/api/v1/negotiations"
  },
  "粘贴买家最新回复：": {
    "en": "Paste buyer's latest reply:",
    "ja": "買い手の最新返信を貼り付け：",
    "de": "Letzte Antwort des Käufers einfügen:",
    "fr": "Collez la dernière réponse de l'acheteur :",
    "es": "Pegue la última respuesta del comprador:"
  },
  "合同草稿已生成，请到\"合同\"页查看": {
    "en": "Contract draft generated, go to \"Contracts\" page to view",
    "ja": "契約ドラフトが生成されました。「契約」ページでご確認ください",
    "de": "Vertragsentwurf erstellt, bitte auf der Seite \"Verträge\" ansehen",
    "fr": "Projet de contrat généré, veuillez consulter la page \"Contrats\"",
    "es": "Borrador de contrato generado, vaya a la página \"Contratos\" para verlo"
  },
  "输入买家回复": {
    "en": "Enter buyer's reply",
    "ja": "買い手の返信を入力",
    "de": "Antwort des Käufers eingeben",
    "fr": "Saisir la réponse de l'acheteur",
    "es": "Ingrese la respuesta del comprador"
  },
  "📄 生成合同": {
    "en": "📄 Generate Contract",
    "ja": "📄 契約生成",
    "de": "📄 Vertrag generieren",
    "fr": "📄 Générer le contrat",
    "es": "📄 Generar contrato"
  },
  "AI 谈判官": {
    "en": "AI Negotiator",
    "ja": "AI交渉官",
    "de": "KI-Verhandler",
    "fr": "Négociateur IA",
    "es": "Negociador IA"
  },
  "轮次": {
    "en": "Round",
    "ja": "ラウンド",
    "de": "Runde",
    "fr": "Tour",
    "es": "Ronda"
  },
  "当前报价": {
    "en": "Current Offer",
    "ja": "現在のオファー",
    "de": "Aktuelles Angebot",
    "fr": "Offre actuelle",
    "es": "Oferta actual"
  },
  "更新时间": {
    "en": "Update Time",
    "ja": "更新時間",
    "de": "Aktualisierungszeit",
    "fr": "Heure de mise à jour",
    "es": "Hora de actualización"
  },
  "暂无谈判 — 从询盘页开启": {
    "en": "No negotiations yet — start from inquiries page",
    "ja": "交渉はまだありません — 問い合わせページから開始",
    "de": "Noch keine Verhandlungen — von der Anfrageseite starten",
    "fr": "Aucune négociation pour l'instant — démarrer depuis la page des demandes",
    "es": "Aún no hay negociaciones — iniciar desde la página de consultas"
  },
  "/api/v1/rules": {
    "en": "/api/v1/rules",
    "ja": "/api/v1/rules",
    "de": "/api/v1/rules",
    "fr": "/api/v1/rules",
    "es": "/api/v1/rules"
  },
  "请填写产品关键词": {
    "en": "Please enter product keywords",
    "ja": "製品キーワードを入力してください",
    "de": "Bitte Produktschlüsselwörter eingeben",
    "fr": "Veuillez saisir les mots-clés du produit",
    "es": "Por favor, ingrese las palabras clave del producto"
  },
  "批发定价规则（谈判底价护栏）": {
    "en": "Wholesale Pricing Rules (Negotiation Floor Guardrails)",
    "ja": "卸売価格ルール（交渉下限ガードレール）",
    "de": "Großhandelspreise (Verhandlungsuntergrenzen)",
    "fr": "Règles de prix de gros (garde-fous de négociation)",
    "es": "Reglas de precios al por mayor (barandillas de precio mínimo de negociación)"
  },
  "产品名/SKU 关键词": {
    "en": "Product Name / SKU Keywords",
    "ja": "製品名/SKUキーワード",
    "de": "Produktname / SKU-Schlüsselwörter",
    "fr": "Nom du produit / Mots-clés SKU",
    "es": "Nombre del producto / Palabras clave SKU"
  },
  "成本$": {
    "en": "Cost $",
    "ja": "コスト$",
    "de": "Kosten $",
    "fr": "Coût $",
    "es": "Costo $"
  },
  "单位成本": {
    "en": "Unit Cost",
    "ja": "単価コスト",
    "de": "Stückkosten",
    "fr": "Coût unitaire",
    "es": "Costo unitario"
  },
  "零售价$": {
    "en": "Retail Price $",
    "ja": "小売価格$",
    "de": "Einzelhandelspreis $",
    "fr": "Prix de détail $",
    "es": "Precio minorista $"
  },
  "零售价": {
    "en": "Retail Price",
    "ja": "小売価格",
    "de": "Einzelhandelspreis",
    "fr": "Prix de détail",
    "es": "Precio minorista"
  },
  "底线毛利%": {
    "en": "Min Margin%",
    "ja": "最低粗利%",
    "de": "Mindestmarge%",
    "fr": "Marge min%",
    "es": "Margen min%"
  },
  "毛利底线": {
    "en": "Margin Floor",
    "ja": "粗利下限",
    "de": "Margenuntergrenze",
    "fr": "Seuil de marge",
    "es": "Piso de margen"
  },
  "最低起订量": {
    "en": "MOQ",
    "ja": "最低注文数量",
    "de": "Mindestbestellmenge",
    "fr": "Quantité min de commande",
    "es": "Cantidad mínima de pedido"
  },
  "产品": {
    "en": "Product",
    "ja": "製品",
    "de": "Produkt",
    "fr": "Produit",
    "es": "Producto"
  },
  "底线毛利": {
    "en": "Floor Margin",
    "ja": "下限粗利",
    "de": "Mindestmarge",
    "fr": "Marge plancher",
    "es": "Margen mínimo"
  },
  "阶梯": {
    "en": "Tier",
    "ja": "段階",
    "de": "Stufe",
    "fr": "Palier",
    "es": "Escalón"
  },
  "暂无规则 — 谈判前请先配置产品成本与底线": {
    "en": "No rules yet — configure product cost and floor before negotiation",
    "ja": "ルールなし — 交渉前に製品原価と下限を設定してください",
    "de": "Keine Regeln — konfigurieren Sie Produktkosten und Untergrenze vor der Verhandlung",
    "fr": "Aucune règle — configurez le coût produit et le seuil avant la négociation",
    "es": "Sin reglas — configure el costo del producto y el piso antes de negociar"
  },
  "/api/v1/contracts": {
    "en": "/api/v1/contracts",
    "ja": "/api/v1/contracts",
    "de": "/api/v1/contracts",
    "fr": "/api/v1/contracts",
    "es": "/api/v1/contracts"
  },
  "🛒 创建批发订单": {
    "en": "🛒 Create Wholesale Order",
    "ja": "🛒 卸注文を作成",
    "de": "🛒 Großhandelsbestellung erstellen",
    "fr": "🛒 Créer une commande en gros",
    "es": "🛒 Crear pedido al por mayor"
  },
  "合同": {
    "en": "Contract",
    "ja": "契約",
    "de": "Vertrag",
    "fr": "Contrat",
    "es": "Contrato"
  },
  "暂无合同 — 谈判成交后生成": {
    "en": "No contracts yet — generated after negotiation closes",
    "ja": "契約なし — 交渉成立後に生成",
    "de": "Keine Verträge — werden nach Verhandlungsabschluss erstellt",
    "fr": "Aucun contrat — généré après la conclusion de la négociation",
    "es": "Sin contratos — se generan después del cierre de la negociación"
  },
  "B2B 批发智能谈判 — 询盘解析 · 毛利护栏状态机 · 阶梯合同 · 批发订单": {
    "en": "B2B Wholesale Smart Negotiation — Inquiry Parsing · Margin Guard State Machine · Tiered Contracts · Wholesale Orders",
    "ja": "B2B卸スマート交渉 — 問い合わせ解析 · 粗利ガードステートマシン · 段階契約 · 卸注文",
    "de": "B2B Großhandel Smart Negotiation — Anfrageanalyse · Margenschutz Zustandsmaschine · Stufenverträge · Großhandelsbestellungen",
    "fr": "Négociation intelligente B2B — Analyse des demandes · Machine d'état de garde de marge · Contrats par paliers · Commandes en gros",
    "es": "Negociación inteligente B2B — Análisis de consultas · Máquina de estado de protección de margen · Contratos escalonados · Pedidos al por mayor"
  },
  "询盘": {
    "en": "Inquiry",
    "ja": "問い合わせ",
    "de": "Anfrage",
    "fr": "Demande",
    "es": "Consulta"
  },
  "谈判": {
    "en": "Negotiation",
    "ja": "交渉",
    "de": "Verhandlung",
    "fr": "Négociation",
    "es": "Negociación"
  },
  "/api/v1/calls-stats": {
    "en": "/api/v1/calls-stats",
    "ja": "/api/v1/calls-stats",
    "de": "/api/v1/calls-stats",
    "fr": "/api/v1/calls-stats",
    "es": "/api/v1/calls-stats"
  },
  "/api/v1/calls": {
    "en": "/api/v1/calls",
    "ja": "/api/v1/calls",
    "de": "/api/v1/calls",
    "fr": "/api/v1/calls",
    "es": "/api/v1/calls"
  },
  "30天通话": {
    "en": "30-Day Calls",
    "ja": "30日間の通話",
    "de": "30-Tage-Anrufe",
    "fr": "Appels sur 30 jours",
    "es": "Llamadas de 30 días"
  },
  "自助解决率": {
    "en": "Self-Service Resolution Rate",
    "ja": "セルフ解決率",
    "de": "Selbstlösungsrate",
    "fr": "Taux de résolution en libre-service",
    "es": "Tasa de resolución autoservicio"
  },
  "WISMO 查单": {
    "en": "WISMO Order Tracking",
    "ja": "WISMO注文追跡",
    "de": "WISMO Auftragsverfolgung",
    "fr": "Suivi de commande WISMO",
    "es": "Seguimiento de pedidos WISMO"
  },
  "平均时长": {
    "en": "Avg Duration",
    "ja": "平均時間",
    "de": "Durchschnittliche Dauer",
    "fr": "Durée moyenne",
    "es": "Duración media"
  },
  "通话": {
    "en": "Call",
    "ja": "通話",
    "de": "Anruf",
    "fr": "Appel",
    "es": "Llamada"
  },
  "来电": {
    "en": "Incoming",
    "ja": "着信",
    "de": "Eingehend",
    "fr": "Entrant",
    "es": "Entrante"
  },
  "情绪": {
    "en": "Sentiment",
    "ja": "感情",
    "de": "Stimmung",
    "fr": "Sentiment",
    "es": "Sentimiento"
  },
  "暂无通话记录 — 可在\"对话模拟\"测试": {
    "en": "No call logs yet — test in \"Dialogue Simulator\"",
    "ja": "通話記録なし — 「対話シミュレーター」でテスト可能",
    "de": "Keine Anrufaufzeichnungen — im \"Dialogsimulator\" testen",
    "fr": "Aucun journal d'appel — testez dans le \"Simulateur de dialogue\"",
    "es": "Sin registros de llamadas — pruebe en el \"Simulador de diálogo\""
  },
  "对话模拟器（模拟 ASR 文本输入，验证编排逻辑）": {
    "en": "Dialogue Simulator (simulate ASR text input, verify orchestration logic)",
    "ja": "対話シミュレーター（ASRテキスト入力をシミュレートし、オーケストレーションロジックを検証）",
    "de": "Dialogsimulator (simuliert ASR-Text-Eingabe, validiert Orchestrierungslogik)",
    "fr": "Simulateur de dialogue (simule la saisie de texte ASR, vérifie la logique d'orchestration)",
    "es": "Simulador de diálogo (simula entrada de texto ASR, verifica la lógica de orquestación)"
  },
  "中文": {
    "en": "Chinese",
    "ja": "中国語",
    "de": "Chinesisch",
    "fr": "Chinois",
    "es": "Chino"
  },
  "📞 开始模拟通话": {
    "en": "📞 Start Simulated Call",
    "ja": "📞 シミュレーション通話を開始",
    "de": "📞 Simulierten Anruf starten",
    "fr": "📞 Démarrer l'appel simulé",
    "es": "📞 Iniciar llamada simulada"
  },
  "AI 思考中...": {
    "en": "AI thinking...",
    "ja": "AI思考中...",
    "de": "KI denkt nach...",
    "fr": "IA réfléchit...",
    "es": "IA pensando..."
  },
  "说点什么...（如：我的订单 #1001 到哪了）": {
    "en": "Say something... (e.g., Where is my order #1001?)",
    "ja": "何か言ってください...（例：注文 #1001 はどこですか？）",
    "de": "Sagen Sie etwas... (z.B. Wo ist meine Bestellung #1001?)",
    "fr": "Dites quelque chose... (ex: Où est ma commande #1001?)",
    "es": "Diga algo... (ej: ¿Dónde está mi pedido #1001?)"
  },
  "发送": {
    "en": "Send",
    "ja": "送信",
    "de": "Senden",
    "fr": "Envoyer",
    "es": "Enviar"
  },
  "挂断": {
    "en": "Hang Up",
    "ja": "切断",
    "de": "Auflegen",
    "fr": "Raccrocher",
    "es": "Colgar"
  },
  "人工转接规则": {
    "en": "Manual Transfer Rules",
    "ja": "手動転送ルール",
    "de": "Manuelle Weiterleitungsregeln",
    "fr": "Règles de transfert manuel",
    "es": "Reglas de transferencia manual"
  },
  "强制转人工的意图（逗号分隔）": {
    "en": "Intents for forced manual transfer (comma-separated)",
    "ja": "強制手動転送のインテント（カンマ区切り）",
    "de": "Intents für erzwungene manuelle Weiterleitung (kommagetrennt)",
    "fr": "Intentions pour transfert manuel forcé (séparées par des virgules)",
    "es": "Intenciones para transferencia manual forzada (separadas por comas)"
  },
  "人工客服电话": {
    "en": "Manual Customer Service Phone",
    "ja": "有人カスタマーサービス電話",
    "de": "Telefon des manuellen Kundendienstes",
    "fr": "Téléphone du service client manuel",
    "es": "Teléfono de atención al cliente manual"
  },
  "多语言 AI 电话客服 — WISMO 查单 · 情绪识别 · 平滑转人工": {
    "en": "Multilingual AI Phone Support — WISMO Order Tracking · Sentiment Detection · Smooth Transfer to Human",
    "ja": "多言語AI電話サポート — WISMO注文追跡 · 感情認識 · スムーズな有人転送",
    "de": "Mehrsprachiger KI-Telefonsupport — WISMO Auftragsverfolgung · Stimmungserkennung · Sanfte Übergabe an Menschen",
    "fr": "Support téléphonique IA multilingue — Suivi de commande WISMO · Détection des sentiments · Transfert fluide vers un humain",
    "es": "Soporte telefónico multilingüe con IA — Seguimiento de pedidos WISMO · Detección de sentimientos · Transferencia fluida a humano"
  },
  "通话记录": {
    "en": "Call Logs",
    "ja": "通話記録",
    "de": "Anrufaufzeichnungen",
    "fr": "Journaux d'appels",
    "es": "Registros de llamadas"
  },
  "对话模拟": {
    "en": "Dialogue Simulator",
    "ja": "対話シミュレーター",
    "de": "Dialogsimulator",
    "fr": "Simulateur de dialogue",
    "es": "Simulador de diálogo"
  },
  "转接规则": {
    "en": "Transfer Rules",
    "ja": "転送ルール",
    "de": "Weiterleitungsregeln",
    "fr": "Règles de transfert",
    "es": "Reglas de transferencia"
  },
  "已达成": {
    "en": "Closed Won",
    "ja": "成約済み",
    "de": "Abgeschlossen gewonnen",
    "fr": "Gagné",
    "es": "Ganado"
  },
  "已寄样": {
    "en": "Sample Sent",
    "ja": "サンプル送付済み",
    "de": "Muster gesendet",
    "fr": "Échantillon envoyé",
    "es": "Muestra enviada"
  },
  "已发布": {
    "en": "Published",
    "ja": "公開済み",
    "de": "Veröffentlicht",
    "fr": "Publié",
    "es": "Publicado"
  },
  "已完成": {
    "en": "Completed",
    "ja": "完了",
    "de": "Abgeschlossen",
    "fr": "Terminé",
    "es": "Completado"
  },
  "已取消": {
    "en": "Cancelled",
    "ja": "キャンセル済み",
    "de": "Abgebrochen",
    "fr": "Annulé",
    "es": "Cancelado"
  },
  "/api/v1/creators": {
    "en": "/api/v1/creators",
    "ja": "/api/v1/creators",
    "de": "/api/v1/creators",
    "fr": "/api/v1/creators",
    "es": "/api/v1/creators"
  },
  "请填写达人账号": {
    "en": "Please enter creator account",
    "ja": "クリエイターアカウントを入力してください",
    "de": "Bitte Creator-Konto eingeben",
    "fr": "Veuillez saisir le compte créateur",
    "es": "Ingrese la cuenta del creador"
  },
  "寄样商品（描述）：": {
    "en": "Sample product (description):",
    "ja": "サンプル商品（説明）：",
    "de": "Musterprodukt (Beschreibung):",
    "fr": "Produit échantillon (description) :",
    "es": "Producto de muestra (descripción):"
  },
  "专属折扣码（用于效果归因）：": {
    "en": "Exclusive discount code (for attribution):",
    "ja": "専用割引コード（効果帰属用）：",
    "de": "Exklusiver Rabattcode (für Attribution):",
    "fr": "Code promo exclusif (pour attribution) :",
    "es": "Código de descuento exclusivo (para atribución):"
  },
  "合作已创建": {
    "en": "Collaboration created",
    "ja": "コラボレーション作成済み",
    "de": "Kooperation erstellt",
    "fr": "Collaboration créée",
    "es": "Colaboración creada"
  },
  "粉丝数": {
    "en": "Followers",
    "ja": "フォロワー数",
    "de": "Follower",
    "fr": "Abonnés",
    "es": "Seguidores"
  },
  "互动率%": {
    "en": "Engagement rate %",
    "ja": "エンゲージメント率%",
    "de": "Interaktionsrate %",
    "fr": "Taux d'engagement %",
    "es": "Tasa de interacción %"
  },
  "垂类": {
    "en": "Niche",
    "ja": "ニッチ",
    "de": "Nische",
    "fr": "Niches",
    "es": "Nicho"
  },
  "地区": {
    "en": "Region",
    "ja": "地域",
    "de": "Region",
    "fr": "Région",
    "es": "Región"
  },
  "＋ 添加达人": {
    "en": "+ Add creator",
    "ja": "+ クリエイターを追加",
    "de": "+ Creator hinzufügen",
    "fr": "+ Ajouter un créateur",
    "es": "+ Añadir creador"
  },
  "已标记发送": {
    "en": "Marked as sent",
    "ja": "送信済みとマーク",
    "de": "Als gesendet markiert",
    "fr": "Marqué comme envoyé",
    "es": "Marcado como enviado"
  },
  "达人": {
    "en": "Creator",
    "ja": "クリエイター",
    "de": "Creator",
    "fr": "Créateur",
    "es": "Creador"
  },
  "粉丝": {
    "en": "Followers",
    "ja": "フォロワー",
    "de": "Follower",
    "fr": "Abonnés",
    "es": "Seguidores"
  },
  "互动率": {
    "en": "Engagement rate",
    "ja": "エンゲージメント率",
    "de": "Interaktionsrate",
    "fr": "Taux d'engagement",
    "es": "Tasa de interacción"
  },
  "匹配度": {
    "en": "Match score",
    "ja": "マッチ度",
    "de": "Übereinstimmung",
    "fr": "Score de correspondance",
    "es": "Puntuación de coincidencia"
  },
  "评估": {
    "en": "Evaluate",
    "ja": "評価",
    "de": "Bewerten",
    "fr": "Évaluer",
    "es": "Evaluar"
  },
  "外联": {
    "en": "Outreach",
    "ja": "アウトリーチ",
    "de": "Outreach",
    "fr": "Prospection",
    "es": "Divulgación"
  },
  "建合作": {
    "en": "Create collab",
    "ja": "コラボ作成",
    "de": "Kooperation erstellen",
    "fr": "Créer collaboration",
    "es": "Crear colaboración"
  },
  "暂无达人 — 添加候选达人开始": {
    "en": "No creators yet — add candidate creators to start",
    "ja": "まだクリエイターがいません — 候補クリエイターを追加して開始",
    "de": "Noch keine Creator — füge Kandidaten hinzu, um zu starten",
    "fr": "Aucun créateur pour l'instant — ajoutez des créateurs candidats pour commencer",
    "es": "Aún no hay creadores — añade creadores candidatos para empezar"
  },
  "/api/v1/outreach": {
    "en": "/api/v1/outreach",
    "ja": "/api/v1/outreach",
    "de": "/api/v1/outreach",
    "fr": "/api/v1/outreach",
    "es": "/api/v1/outreach"
  },
  "粘贴达人回复内容：": {
    "en": "Paste creator reply:",
    "ja": "クリエイターの返信を貼り付け：",
    "de": "Creator-Antwort einfügen:",
    "fr": "Collez la réponse du créateur :",
    "es": "Pegar respuesta del creador:"
  },
  "消息": {
    "en": "Message",
    "ja": "メッセージ",
    "de": "Nachricht",
    "fr": "Message",
    "es": "Mensaje"
  },
  "记录回复": {
    "en": "Log reply",
    "ja": "返信を記録",
    "de": "Antwort protokollieren",
    "fr": "Enregistrer la réponse",
    "es": "Registrar respuesta"
  },
  "暂无外联记录": {
    "en": "No outreach records yet",
    "ja": "アウトリーチ記録はまだありません",
    "de": "Noch keine Outreach-Aufzeichnungen",
    "fr": "Aucun enregistrement de prospection pour l'instant",
    "es": "Aún no hay registros de divulgación"
  },
  "/api/v1/collabs": {
    "en": "/api/v1/collabs",
    "ja": "/api/v1/collabs",
    "de": "/api/v1/collabs",
    "fr": "/api/v1/collabs",
    "es": "/api/v1/collabs"
  },
  "归因 GMV $？": {
    "en": "Attributed GMV $?",
    "ja": "帰属GMV $？",
    "de": "Zugeschriebener GMV $?",
    "fr": "GMV attribué $ ?",
    "es": "¿GMV atribuido $?"
  },
  "归因订单数？": {
    "en": "Attributed orders?",
    "ja": "帰属注文数？",
    "de": "Zugeschriebene Bestellungen?",
    "fr": "Commandes attribuées ?",
    "es": "¿Pedidos atribuidos?"
  },
  "阶段": {
    "en": "Stage",
    "ja": "ステージ",
    "de": "Phase",
    "fr": "Étape",
    "es": "Etapa"
  },
  "寄样": {
    "en": "Sample sent",
    "ja": "サンプル送付",
    "de": "Muster versendet",
    "fr": "Échantillon envoyé",
    "es": "Muestra enviada"
  },
  "发布链接": {
    "en": "Publish link",
    "ja": "公開リンク",
    "de": "Veröffentlichungslink",
    "fr": "Lien de publication",
    "es": "Enlace de publicación"
  },
  "折扣码": {
    "en": "Discount code",
    "ja": "割引コード",
    "de": "Rabattcode",
    "fr": "Code promo",
    "es": "Código de descuento"
  },
  "归因 GMV": {
    "en": "Attributed GMV",
    "ja": "帰属GMV",
    "de": "Zugeschriebener GMV",
    "fr": "GMV attribué",
    "es": "GMV atribuido"
  },
  "录入效果": {
    "en": "Record performance",
    "ja": "効果を記録",
    "de": "Leistung erfassen",
    "fr": "Enregistrer les performances",
    "es": "Registrar rendimiento"
  },
  "暂无合作 — 在达人库中对已回复的达人\"建合作\"": {
    "en": "No collabs yet — in creator library, click \"Create collab\" for replied creators",
    "ja": "まだコラボがありません — クリエイターライブラリで返信済みクリエイターに「コラボ作成」",
    "de": "Noch keine Kooperationen — in der Creator-Bibliothek für geantwortete Creator \"Kooperation erstellen\"",
    "fr": "Aucune collaboration pour l'instant — dans la bibliothèque de créateurs, cliquez sur \"Créer collaboration\" pour les créateurs ayant répondu",
    "es": "Aún no hay colaboraciones — en la biblioteca de creadores, haga clic en \"Crear colaboración\" para los creadores que respondieron"
  },
  "达人 UGC 匹配管理 — AI 匹配评估 · 自动外联 · 合作流看板": {
    "en": "Creator UGC Match Management — AI Match Evaluation · Auto Outreach · Collab Flow Dashboard",
    "ja": "クリエイターUGCマッチ管理 — AIマッチ評価 · 自動アウトリーチ · コラボフローダッシュボード",
    "de": "Creator-UGC-Match-Management — AI-Match-Bewertung · Automatischer Outreach · Kooperationsfluss-Dashboard",
    "fr": "Gestion des correspondances UGC des créateurs — Évaluation de correspondance IA · Prospection automatique · Tableau de bord des flux de collaboration",
    "es": "Gestión de coincidencias UGC de creadores — Evaluación de coincidencias IA · Divulgación automática · Panel de flujo de colaboración"
  },
  "达人库": {
    "en": "Creator Library",
    "ja": "クリエイターライブラリ",
    "de": "Creator-Bibliothek",
    "fr": "Bibliothèque de créateurs",
    "es": "Biblioteca de creadores"
  },
  "外联记录": {
    "en": "Outreach Records",
    "ja": "アウトリーチ記録",
    "de": "Outreach-Aufzeichnungen",
    "fr": "Enregistrements de prospection",
    "es": "Registros de divulgación"
  },
  "合作看板": {
    "en": "Collaboration Dashboard",
    "ja": "協力ダッシュボード",
    "de": "Kooperations-Dashboard",
    "fr": "Tableau de bord de collaboration",
    "es": "Panel de colaboración"
  },
  "/api/v1/propensity": {
    "en": "/api/v1/propensity",
    "ja": "/api/v1/propensity",
    "de": "/api/v1/propensity",
    "fr": "/api/v1/propensity",
    "es": "/api/v1/propensity"
  },
  "/api/v1/stats": {
    "en": "/api/v1/stats",
    "ja": "/api/v1/stats",
    "de": "/api/v1/stats",
    "fr": "/api/v1/stats",
    "es": "/api/v1/stats"
  },
  "/api/v1/propensity/compute": {
    "en": "/api/v1/propensity/compute",
    "ja": "/api/v1/propensity/compute",
    "de": "/api/v1/propensity/compute",
    "fr": "/api/v1/propensity/compute",
    "es": "/api/v1/propensity/compute"
  },
  "优惠包总数": {
    "en": "Total Offers",
    "ja": "オファー総数",
    "de": "Angebote gesamt",
    "fr": "Total des offres",
    "es": "Total de ofertas"
  },
  "已触达": {
    "en": "Reached",
    "ja": "リーチ済み",
    "de": "Erreicht",
    "fr": "Atteint",
    "es": "Alcanzado"
  },
  "已转化订阅": {
    "en": "Converted Subscriptions",
    "ja": "コンバージョン済みサブスクリプション",
    "de": "Konvertierte Abonnements",
    "fr": "Abonnements convertis",
    "es": "Suscripciones convertidas"
  },
  "转化率": {
    "en": "Conversion Rate",
    "ja": "コンバージョン率",
    "de": "Konversionsrate",
    "fr": "Taux de conversion",
    "es": "Tasa de conversión"
  },
  "🔮 计算订阅倾向": {
    "en": "🔮 Compute Subscription Propensity",
    "ja": "🔮 サブスクリプション傾向を計算",
    "de": "🔮 Abonnement-Neigung berechnen",
    "fr": "🔮 Calculer la propension d'abonnement",
    "es": "🔮 Calcular propensión a suscripción"
  },
  "🎁 生成定向优惠包": {
    "en": "🎁 Generate Targeted Offers",
    "ja": "🎁 ターゲットオファーを生成",
    "de": "🎁 Gezielte Angebote generieren",
    "fr": "🎁 Générer des offres ciblées",
    "es": "🎁 Generar ofertas dirigidas"
  },
  "倾向分": {
    "en": "Propensity Score",
    "ja": "傾向スコア",
    "de": "Neigungswert",
    "fr": "Score de propension",
    "es": "Puntuación de propensión"
  },
  "核心商品": {
    "en": "Core Products",
    "ja": "コア商品",
    "de": "Kernprodukte",
    "fr": "Produits principaux",
    "es": "Productos principales"
  },
  "复购次数": {
    "en": "Repeat Purchases",
    "ja": "リピート購入回数",
    "de": "Wiederholungskäufe",
    "fr": "Achats répétés",
    "es": "Compras repetidas"
  },
  "周期": {
    "en": "Cycle",
    "ja": "周期",
    "de": "Zyklus",
    "fr": "Cycle",
    "es": "Ciclo"
  },
  "评分因素": {
    "en": "Scoring Factors",
    "ja": "スコアリング要素",
    "de": "Bewertungsfaktoren",
    "fr": "Facteurs de notation",
    "es": "Factores de puntuación"
  },
  "暂无评分 — 点击\"计算订阅倾向\"": {
    "en": "No score yet — Click \"Compute Subscription Propensity\"",
    "ja": "まだスコアがありません — 「サブスクリプション傾向を計算」をクリック",
    "de": "Noch keine Bewertung — Klicken Sie auf \"Abonnement-Neigung berechnen\"",
    "fr": "Pas encore de score — Cliquez sur \"Calculer la propension d'abonnement\"",
    "es": "Sin puntuación aún — Haga clic en \"Calcular propensión a suscripción\""
  },
  "/api/v1/offers": {
    "en": "/api/v1/offers",
    "ja": "/api/v1/offers",
    "de": "/api/v1/offers",
    "fr": "/api/v1/offers",
    "es": "/api/v1/offers"
  },
  "频率": {
    "en": "Frequency",
    "ja": "頻度",
    "de": "Häufigkeit",
    "fr": "Fréquence",
    "es": "Frecuencia"
  },
  "折扣": {
    "en": "Discount",
    "ja": "割引",
    "de": "Rabatt",
    "fr": "Remise",
    "es": "Descuento"
  },
  "年省": {
    "en": "Annual Savings",
    "ja": "年間節約額",
    "de": "Jährliche Ersparnis",
    "fr": "Économies annuelles",
    "es": "Ahorro anual"
  },
  "话术": {
    "en": "Script",
    "ja": "トークスクリプト",
    "de": "Ansprache",
    "fr": "Discours",
    "es": "Guión"
  },
  "标记触达": {
    "en": "Mark Reached",
    "ja": "リーチ済みとしてマーク",
    "de": "Als erreicht markieren",
    "fr": "Marquer comme atteint",
    "es": "Marcar como alcanzado"
  },
  "已转化": {
    "en": "Converted",
    "ja": "コンバージョン済み",
    "de": "Konvertiert",
    "fr": "Converti",
    "es": "Convertido"
  },
  "同步平台": {
    "en": "Sync Platform",
    "ja": "同期プラットフォーム",
    "de": "Sync-Plattform",
    "fr": "Plateforme de synchronisation",
    "es": "Plataforma de sincronización"
  },
  "暂无优惠包": {
    "en": "No Offers Yet",
    "ja": "まだオファーがありません",
    "de": "Noch keine Angebote",
    "fr": "Pas encore d'offres",
    "es": "Aún no hay ofertas"
  },
  "超个性化订阅转化 — 倾向预测 · 定向优惠包 · 平台同步": {
    "en": "Hyper-Personalized Subscription Conversion — Propensity Prediction · Targeted Offers · Platform Sync",
    "ja": "超パーソナライズされたサブスクリプションコンバージョン — 傾向予測 · ターゲットオファー · プラットフォーム同期",
    "de": "Hyper-personalisierte Abonnement-Konvertierung — Neigungsvorhersage · Gezielte Angebote · Plattform-Sync",
    "fr": "Conversion d'abonnement hyper-personnalisée — Prédiction de propension · Offres ciblées · Synchronisation de plateforme",
    "es": "Conversión de suscripción hiperpersonalizada — Predicción de propensión · Ofertas dirigidas · Sincronización de plataforma"
  },
  "倾向评分": {
    "en": "Propensity Scoring",
    "ja": "傾向スコアリング",
    "de": "Neigungsbewertung",
    "fr": "Notation de propension",
    "es": "Puntuación de propensión"
  },
  "定向优惠包": {
    "en": "Targeted Offers",
    "ja": "ターゲットオファー",
    "de": "Gezielte Angebote",
    "fr": "Offres ciblées",
    "es": "Ofertas dirigidas"
  },
  "/api/v1/catalog/sync": {
    "en": "/api/v1/catalog/sync",
    "ja": "/api/v1/catalog/sync",
    "de": "/api/v1/catalog/sync",
    "fr": "/api/v1/catalog/sync",
    "es": "/api/v1/catalog/sync"
  },
  "📦 同步产品目录": {
    "en": "📦 Sync Product Catalog",
    "ja": "📦 商品カタログを同期",
    "de": "📦 Produktkatalog synchronisieren",
    "fr": "📦 Synchroniser le catalogue de produits",
    "es": "📦 Sincronizar catálogo de productos"
  },
  "🎯 开始 Quiz 体验": {
    "en": "🎯 Start Quiz Experience",
    "ja": "🎯 クイズ体験を開始",
    "de": "🎯 Quiz-Erfahrung starten",
    "fr": "🎯 Démarrer l'expérience Quiz",
    "es": "🎯 Iniciar experiencia de Quiz"
  },
  "回答问题...": {
    "en": "Answer questions...",
    "ja": "質問に答える...",
    "de": "Fragen beantworten...",
    "fr": "Répondre aux questions...",
    "es": "Responder preguntas..."
  },
  "🎁 个性化推荐": {
    "en": "🎁 Personalized Recommendations",
    "ja": "🎁 パーソナライズされたおすすめ",
    "de": "🎁 Personalisierte Empfehlungen",
    "fr": "🎁 Recommandations personnalisées",
    "es": "🎁 Recomendaciones personalizadas"
  },
  "/api/v1/quiz/sessions": {
    "en": "/api/v1/quiz/sessions",
    "ja": "/api/v1/quiz/sessions",
    "de": "/api/v1/quiz/sessions",
    "fr": "/api/v1/quiz/sessions",
    "es": "/api/v1/quiz/sessions"
  },
  "偏好": {
    "en": "Preferences",
    "ja": "嗜好",
    "de": "Präferenzen",
    "fr": "Préférences",
    "es": "Preferencias"
  },
  "推荐数": {
    "en": "Recommendations Count",
    "ja": "推奨数",
    "de": "Anzahl Empfehlungen",
    "fr": "Nombre de recommandations",
    "es": "Número de recomendaciones"
  },
  "匿名": {
    "en": "Anonymous",
    "ja": "匿名",
    "de": "Anonym",
    "fr": "Anonyme",
    "es": "Anónimo"
  },
  "推送": {
    "en": "Push",
    "ja": "プッシュ",
    "de": "Push",
    "fr": "Push",
    "es": "Push"
  },
  "暂无会话": {
    "en": "No Sessions Yet",
    "ja": "まだセッションがありません",
    "de": "Noch keine Sitzungen",
    "fr": "Pas encore de sessions",
    "es": "Aún no hay sesiones"
  },
  "AI 对话式导购测验 — 多轮诊断 · 个性化推荐 · Klaviyo 触达": {
    "en": "AI Conversational Shopping Quiz — Multi-round Diagnosis · Personalized Recommendations · Klaviyo Reach",
    "ja": "AI 会話型ショッピングクイズ — 多段階診断 · パーソナライズされたおすすめ · Klaviyo リーチ",
    "de": "KI-gestütztes Conversational Shopping Quiz — Mehrstufige Diagnose · Personalisierte Empfehlungen · Klaviyo-Reichweite",
    "fr": "Quiz shopping conversationnel IA — Diagnostic multi-tours · Recommandations personnalisées · Portée Klaviyo",
    "es": "Cuestionario de compras conversacional con IA — Diagnóstico de múltiples rondas · Recomendaciones personalizadas · Alcance de Klaviyo"
  },
  "Quiz 体验": {
    "en": "Quiz Experience",
    "ja": "クイズ体験",
    "de": "Quiz-Erfahrung",
    "fr": "Expérience Quiz",
    "es": "Experiencia de Quiz"
  },
  "会话记录": {
    "en": "Session Records",
    "ja": "セッション記録",
    "de": "Sitzungsaufzeichnungen",
    "fr": "Enregistrements de sessions",
    "es": "Registros de sesión"
  },
  "政策": {
    "en": "Policies",
    "ja": "ポリシー",
    "de": "Richtlinien",
    "fr": "Politiques",
    "es": "Políticas"
  },
  "产品知识": {
    "en": "Product Knowledge",
    "ja": "製品知識",
    "de": "Produktwissen",
    "fr": "Connaissances produit",
    "es": "Conocimiento del producto"
  },
  "/api/v1/kb/entries": {
    "en": "/api/v1/kb/entries",
    "ja": "/api/v1/kb/entries",
    "de": "/api/v1/kb/entries",
    "fr": "/api/v1/kb/entries",
    "es": "/api/v1/kb/entries"
  },
  "/api/v1/kb/stats": {
    "en": "/api/v1/kb/stats",
    "ja": "/api/v1/kb/stats",
    "de": "/api/v1/kb/stats",
    "fr": "/api/v1/kb/stats",
    "es": "/api/v1/kb/stats"
  },
  "标题与内容必填": {
    "en": "Title and content required",
    "ja": "タイトルと内容は必須",
    "de": "Titel und Inhalt erforderlich",
    "fr": "Titre et contenu obligatoires",
    "es": "Título y contenido obligatorios"
  },
  "知识条目": {
    "en": "Knowledge Entry",
    "ja": "知識エントリ",
    "de": "Wissenseintrag",
    "fr": "Entrée de connaissance",
    "es": "Entrada de conocimiento"
  },
  "向量分块": {
    "en": "Vector Chunks",
    "ja": "ベクトルチャンク",
    "de": "Vektor-Chunks",
    "fr": "Blocs vectoriels",
    "es": "Fragmentos vectoriales"
  },
  "待补缺口": {
    "en": "Pending Gaps",
    "ja": "未対応のギャップ",
    "de": "Ausstehende Lücken",
    "fr": "Écarts en attente",
    "es": "Brechas pendientes"
  },
  "新建条目": {
    "en": "New Entry",
    "ja": "新規エントリ",
    "de": "Neuer Eintrag",
    "fr": "Nouvelle entrée",
    "es": "Nueva entrada"
  },
  "标题": {
    "en": "Title",
    "ja": "タイトル",
    "de": "Titel",
    "fr": "Titre",
    "es": "Título"
  },
  "内容（保存后自动向量化）": {
    "en": "Content (auto-vectorized after saving)",
    "ja": "内容（保存後に自動ベクトル化）",
    "de": "Inhalt (nach Speichern automatisch vektorisiert)",
    "fr": "Contenu (vectorisé automatiquement après sauvegarde)",
    "es": "Contenido (vectorizado automáticamente al guardar)"
  },
  "保存并索引": {
    "en": "Save & Index",
    "ja": "保存してインデックス",
    "de": "Speichern und indizieren",
    "fr": "Enregistrer et indexer",
    "es": "Guardar e indexar"
  },
  "取消": {
    "en": "Cancel",
    "ja": "キャンセル",
    "de": "Abbrechen",
    "fr": "Annuler",
    "es": "Cancelar"
  },
  "＋ 新建知识条目": {
    "en": "+ New Knowledge Entry",
    "ja": "＋ 新規知識エントリ",
    "de": "+ Neuer Wissenseintrag",
    "fr": "+ Nouvelle entrée de connaissance",
    "es": "+ Nueva entrada de conocimiento"
  },
  "归档此条目？": {
    "en": "Archive this entry?",
    "ja": "このエントリをアーカイブしますか？",
    "de": "Diesen Eintrag archivieren?",
    "fr": "Archiver cette entrée ?",
    "es": "¿Archivar esta entrada?"
  },
  "归档": {
    "en": "Archive",
    "ja": "アーカイブ",
    "de": "Archivieren",
    "fr": "Archiver",
    "es": "Archivar"
  },
  "暂无条目 — 添加政策、FAQ、品牌声音指南": {
    "en": "No entries yet — Add policies, FAQs, brand voice guides",
    "ja": "エントリがありません — ポリシー、FAQ、ブランドボイスガイドを追加",
    "de": "Noch keine Einträge — Richtlinien, FAQs, Markenstimme hinzufügen",
    "fr": "Aucune entrée — Ajouter politiques, FAQ, guides de voix de marque",
    "es": "Sin entradas aún — Agregar políticas, FAQ, guías de voz de marca"
  },
  "知识库问答测试（与其他 App 调用的 API 相同）": {
    "en": "Knowledge Base Q&A Test (same API used by other apps)",
    "ja": "ナレッジベースQ&Aテスト（他のアプリが呼び出すAPIと同じ）",
    "de": "Wissensdatenbank Q&A-Test (gleiche API wie andere Apps)",
    "fr": "Test Q&A de la base de connaissances (même API que les autres apps)",
    "es": "Prueba de preguntas y respuestas de la base de conocimiento (misma API que otras apps)"
  },
  "如：你们的退货政策是什么？": {
    "en": "e.g., What is your return policy?",
    "ja": "例：返品ポリシーは？",
    "de": "z.B.: Wie lautet Ihre Rückgaberegelung?",
    "fr": "Ex. : Quelle est votre politique de retour ?",
    "es": "Ej.: ¿Cuál es su política de devolución?"
  },
  "提问": {
    "en": "Ask",
    "ja": "質問",
    "de": "Fragen",
    "fr": "Demander",
    "es": "Preguntar"
  },
  "检索到的知识块": {
    "en": "Retrieved Knowledge Chunks",
    "ja": "取得された知識チャンク",
    "de": "Abgerufene Wissens-Chunks",
    "fr": "Blocs de connaissances récupérés",
    "es": "Fragmentos de conocimiento recuperados"
  },
  "/api/v1/gaps": {
    "en": "/api/v1/gaps",
    "ja": "/api/v1/gaps",
    "de": "/api/v1/gaps",
    "fr": "/api/v1/gaps",
    "es": "/api/v1/gaps"
  },
  "知识缺口（客户问了但知识库答不上的问题）": {
    "en": "Knowledge Gaps (questions customers asked but KB couldn't answer)",
    "ja": "知識ギャップ（顧客が質問したがナレッジベースが答えられなかったもの）",
    "de": "Wissenslücken (Fragen, die Kunden stellten, aber die Wissensdatenbank nicht beantworten konnte)",
    "fr": "Lacunes de connaissances (questions posées par les clients auxquelles la base de connaissances n'a pas pu répondre)",
    "es": "Brechas de conocimiento (preguntas que los clientes hicieron pero la base de conocimiento no pudo responder)"
  },
  "问题": {
    "en": "Question",
    "ja": "質問",
    "de": "Frage",
    "fr": "Question",
    "es": "Pregunta"
  },
  "已补充": {
    "en": "Answered",
    "ja": "回答済み",
    "de": "Beantwortet",
    "fr": "Répondu",
    "es": "Respondido"
  },
  "忽略": {
    "en": "Ignore",
    "ja": "無視",
    "de": "Ignorieren",
    "fr": "Ignorer",
    "es": "Ignorar"
  },
  "暂无缺口 🎉": {
    "en": "No gaps yet 🎉",
    "ja": "ギャップはまだありません 🎉",
    "de": "Noch keine Lücken 🎉",
    "fr": "Aucun écart pour l'instant 🎉",
    "es": "Sin brechas aún 🎉"
  },
  "多渠道知识库与品牌声音 — 结构化知识 · RAG 检索 · 缺口监测": {
    "en": "Multi-channel Knowledge Base & Brand Voice — Structured Knowledge · RAG Retrieval · Gap Monitoring",
    "ja": "マルチチャネルナレッジベースとブランドボイス — 構造化知識 · RAG検索 · ギャップ監視",
    "de": "Multi-Channel-Wissensdatenbank & Markenstimme — Strukturiertes Wissen · RAG-Abfrage · Lückenüberwachung",
    "fr": "Base de connaissances multicanal et voix de marque — Connaissances structurées · Recherche RAG · Surveillance des écarts",
    "es": "Base de conocimiento multicanal y voz de marca — Conocimiento estructurado · Búsqueda RAG · Monitoreo de brechas"
  },
  "知识管理": {
    "en": "Knowledge Management",
    "ja": "知識管理",
    "de": "Wissensmanagement",
    "fr": "Gestion des connaissances",
    "es": "Gestión del conocimiento"
  },
  "问答测试": {
    "en": "Q&A Test",
    "ja": "Q&Aテスト",
    "de": "Q&A-Test",
    "fr": "Test Q&A",
    "es": "Prueba de preguntas y respuestas"
  },
  "知识缺口": {
    "en": "Knowledge Gaps",
    "ja": "知識ギャップ",
    "de": "Wissenslücken",
    "fr": "Lacunes de connaissances",
    "es": "Brechas de conocimiento"
  },
  "/api/v1/profiles": {
    "en": "/api/v1/profiles",
    "ja": "/api/v1/profiles",
    "de": "/api/v1/profiles",
    "fr": "/api/v1/profiles",
    "es": "/api/v1/profiles"
  },
  "/api/v1/profiles/build": {
    "en": "/api/v1/profiles/build",
    "ja": "/api/v1/profiles/build",
    "de": "/api/v1/profiles/build",
    "fr": "/api/v1/profiles/build",
    "es": "/api/v1/profiles/build"
  },
  "事实键（如 skin_type / size_top / allergy）：": {
    "en": "Fact Key (e.g., skin_type / size_top / allergy):",
    "ja": "ファクトキー（例：skin_type / size_top / allergy）：",
    "de": "Faktenschlüssel (z.B. skin_type / size_top / allergy):",
    "fr": "Clé de fait (ex. skin_type / size_top / allergy) :",
    "es": "Clave de hecho (ej. skin_type / size_top / allergy):"
  },
  "值：": {
    "en": "Value:",
    "ja": "値：",
    "de": "Wert:",
    "fr": "Valeur :",
    "es": "Valor:"
  },
  "🔄 从订单构建画像": {
    "en": "🔄 Build Profile from Orders",
    "ja": "🔄 注文からプロファイルを構築",
    "de": "🔄 Profil aus Bestellungen erstellen",
    "fr": "🔄 Construire le profil à partir des commandes",
    "es": "🔄 Construir perfil a partir de pedidos"
  },
  "＋ 手动添加事实": {
    "en": "+ Add Fact Manually",
    "ja": "＋ 手動でファクトを追加",
    "de": "+ Manuell Fakt hinzufügen",
    "fr": "+ Ajouter un fait manuellement",
    "es": "+ Agregar hecho manualmente"
  },
  "订单衍生": {
    "en": "Order-derived",
    "ja": "注文由来",
    "de": "Aus Bestellungen abgeleitet",
    "fr": "Dérivé des commandes",
    "es": "Derivado de pedidos"
  },
  "记忆事实": {
    "en": "Memory Facts",
    "ja": "記憶事実",
    "de": "Erinnerungsfakten",
    "fr": "Faits mémorisés",
    "es": "Hechos de memoria"
  },
  "暂无事实": {
    "en": "No facts yet",
    "ja": "まだ事実がありません",
    "de": "Noch keine Fakten",
    "fr": "Aucun fait pour l'instant",
    "es": "Aún no hay hechos"
  },
  "记忆事实数": {
    "en": "Memory Fact Count",
    "ja": "記憶事実数",
    "de": "Anzahl der Erinnerungsfakten",
    "fr": "Nombre de faits mémorisés",
    "es": "Número de hechos de memoria"
  },
  "暂无画像 — 点击\"从订单构建画像\"": {
    "en": "No profile yet — Click \"Build Profile from Orders\"",
    "ja": "まだプロフィールがありません — 「注文からプロフィールを構築」をクリック",
    "de": "Noch kein Profil — Klicken Sie auf \"Profil aus Bestellungen erstellen\"",
    "fr": "Pas encore de profil — Cliquez sur \"Construire le profil à partir des commandes\"",
    "es": "Aún no hay perfil — Haga clic en \"Construir perfil desde pedidos\""
  },
  "客户 ID 与对话内容必填": {
    "en": "Customer ID and conversation content required",
    "ja": "顧客IDと会話内容は必須です",
    "de": "Kunden-ID und Gesprächsinhalt erforderlich",
    "fr": "ID client et contenu de la conversation requis",
    "es": "ID de cliente y contenido de la conversación obligatorios"
  },
  "从对话提取偏好（粘贴客服/导购对话记录）": {
    "en": "Extract preferences from conversation (paste customer service/sales chat)",
    "ja": "会話から嗜好を抽出（カスタマーサービス/販売員の会話記録を貼り付け）",
    "de": "Präferenzen aus Gespräch extrahieren (Kundendienst/Verkaufsgespräch einfügen)",
    "fr": "Extraire les préférences de la conversation (coller le chat du service client/guide)",
    "es": "Extraer preferencias de la conversación (pegar chat de atención al cliente/ventas)"
  },
  "客户 ID（如 gid://shopify/Customer/123）": {
    "en": "Customer ID (e.g., gid://shopify/Customer/123)",
    "ja": "顧客ID（例：gid://shopify/Customer/123）",
    "de": "Kunden-ID (z.B. gid://shopify/Customer/123)",
    "fr": "ID client (ex: gid://shopify/Customer/123)",
    "es": "ID de cliente (ej: gid://shopify/Customer/123)"
  },
  "对话记录...": {
    "en": "Conversation history...",
    "ja": "会話記録...",
    "de": "Gesprächsverlauf...",
    "fr": "Historique de la conversation...",
    "es": "Historial de conversación..."
  },
  "🤖 提取偏好事实": {
    "en": "🤖 Extract Preference Facts",
    "ja": "🤖 嗜好事実を抽出",
    "de": "🤖 Präferenzfakten extrahieren",
    "fr": "🤖 Extraire les faits de préférence",
    "es": "🤖 Extraer hechos de preferencia"
  },
  "客户偏好记忆 — 深度画像 · 对话提取 · 记忆 API（供导购/Quiz 调用）": {
    "en": "Customer Preference Memory — Deep Profile · Chat Extraction · Memory API (for Guide/Quiz)",
    "ja": "顧客嗜好記憶 — 深層プロフィール · 会話抽出 · 記憶API（ガイド/クイズ用）",
    "de": "Kundenpräferenzgedächtnis — Tiefenprofil · Gesprächsextraktion · Memory-API (für Guide/Quiz)",
    "fr": "Mémoire des préférences client — Profil approfondi · Extraction de conversation · API mémoire (pour Guide/Quiz)",
    "es": "Memoria de preferencias del cliente — Perfil profundo · Extracción de conversación · API de memoria (para Guía/Quiz)"
  },
  "客户画像": {
    "en": "Customer Profile",
    "ja": "顧客プロフィール",
    "de": "Kundenprofil",
    "fr": "Profil client",
    "es": "Perfil del cliente"
  },
  "对话提取": {
    "en": "Chat Extraction",
    "ja": "会話抽出",
    "de": "Gesprächsextraktion",
    "fr": "Extraction de conversation",
    "es": "Extracción de conversación"
  },
  "/api/v1/campaigns": {
    "en": "/api/v1/campaigns",
    "ja": "/api/v1/campaigns",
    "de": "/api/v1/campaigns",
    "fr": "/api/v1/campaigns",
    "es": "/api/v1/campaigns"
  },
  "请填写系列名称": {
    "en": "Please enter campaign name",
    "ja": "シリーズ名を入力してください",
    "de": "Bitte geben Sie den Kampagnennamen ein",
    "fr": "Veuillez saisir le nom de la campagne",
    "es": "Por favor, ingrese el nombre de la campaña"
  },
  "点击数？": {
    "en": "Clicks?",
    "ja": "クリック数？",
    "de": "Klicks?",
    "fr": "Clics ?",
    "es": "¿Clics?"
  },
  "T": {
    "en": "T",
    "ja": "T",
    "de": "T",
    "fr": "T",
    "es": "T"
  },
  "已记录": {
    "en": "Recorded",
    "ja": "記録済み",
    "de": "Aufgezeichnet",
    "fr": "Enregistré",
    "es": "Registrado"
  },
  "系列名称": {
    "en": "Campaign Name",
    "ja": "シリーズ名",
    "de": "Kampagnenname",
    "fr": "Nom de la campagne",
    "es": "Nombre de la campaña"
  },
  "日预算": {
    "en": "Daily Budget",
    "ja": "日予算",
    "de": "Tagesbudget",
    "fr": "Budget quotidien",
    "es": "Presupuesto diario"
  },
  "utm_campaign（归因匹配）": {
    "en": "utm_campaign (Attribution Match)",
    "ja": "utm_campaign（アトリビューションマッチ）",
    "de": "utm_campaign (Attributionsabgleich)",
    "fr": "utm_campaign (Correspondance d'attribution)",
    "es": "utm_campaign (Coincidencia de atribución)"
  },
  "🔗 订单归因": {
    "en": "🔗 Order Attribution",
    "ja": "🔗 注文アトリビューション",
    "de": "🔗 Bestellattribution",
    "fr": "🔗 Attribution de commande",
    "es": "🔗 Atribución de pedidos"
  },
  "系列": {
    "en": "Campaign",
    "ja": "シリーズ",
    "de": "Kampagne",
    "fr": "Campagne",
    "es": "Campaña"
  },
  "7天花费": {
    "en": "7-Day Spend",
    "ja": "7日間の支出",
    "de": "7-Tage-Ausgaben",
    "fr": "Dépenses sur 7 jours",
    "es": "Gasto en 7 días"
  },
  "7天收入": {
    "en": "7-Day Revenue",
    "ja": "7日間の収益",
    "de": "7-Tage-Umsatz",
    "fr": "Revenus sur 7 jours",
    "es": "Ingresos en 7 días"
  },
  "录入指标": {
    "en": "Enter Metrics",
    "ja": "指標を入力",
    "de": "Metriken eingeben",
    "fr": "Saisir les métriques",
    "es": "Ingresar métricas"
  },
  "恢复": {
    "en": "Resume",
    "ja": "再開",
    "de": "Fortsetzen",
    "fr": "Reprendre",
    "es": "Reanudar"
  },
  "暂无广告系列": {
    "en": "No campaigns yet",
    "ja": "まだキャンペーンがありません",
    "de": "Noch keine Kampagnen",
    "fr": "Aucune campagne pour l'instant",
    "es": "Aún no hay campañas"
  },
  "/api/v1/optimizer/actions": {
    "en": "/api/v1/optimizer/actions",
    "ja": "/api/v1/optimizer/actions",
    "de": "/api/v1/optimizer/actions",
    "fr": "/api/v1/optimizer/actions",
    "es": "/api/v1/optimizer/actions"
  },
  "/api/v1/optimizer/run": {
    "en": "/api/v1/optimizer/run",
    "ja": "/api/v1/optimizer/run",
    "de": "/api/v1/optimizer/run",
    "fr": "/api/v1/optimizer/run",
    "es": "/api/v1/optimizer/run"
  },
  "⬆ 提额": {
    "en": "⬆ Increase",
    "ja": "⬆ 増額",
    "de": "⬆ Erhöhen",
    "fr": "⬆ Augmenter",
    "es": "⬆ Aumentar"
  },
  "⬇ 降额": {
    "en": "⬇ Decrease",
    "ja": "⬇ 減額",
    "de": "⬇ Verringern",
    "fr": "⬇ Diminuer",
    "es": "⬇ Disminuir"
  },
  "⏸ 暂停": {
    "en": "⏸ Pause",
    "ja": "⏸ 一時停止",
    "de": "⏸ Pausieren",
    "fr": "⏸ Mettre en pause",
    "es": "⏸ Pausar"
  },
  "▶ 恢复": {
    "en": "▶ Resume",
    "ja": "▶ 再開",
    "de": "▶ Fortsetzen",
    "fr": "▶ Reprendre",
    "es": "▶ Reanudar"
  },
  "预算调优建议": {
    "en": "Budget Optimization Suggestions",
    "ja": "予算最適化の提案",
    "de": "Budgetoptimierungsvorschläge",
    "fr": "Suggestions d'optimisation du budget",
    "es": "Sugerencias de optimización de presupuesto"
  },
  "⚡ 运行调优引擎": {
    "en": "⚡ Run Optimization Engine",
    "ja": "⚡ 最適化エンジンを実行",
    "de": "⚡ Optimierungs-Engine ausführen",
    "fr": "⚡ Exécuter le moteur d'optimisation",
    "es": "⚡ Ejecutar motor de optimización"
  },
  "动作": {
    "en": "Action",
    "ja": "アクション",
    "de": "Aktion",
    "fr": "Action",
    "es": "Acción"
  },
  "预算变化": {
    "en": "Budget Change",
    "ja": "予算変更",
    "de": "Budgetänderung",
    "fr": "Changement de budget",
    "es": "Cambio de presupuesto"
  },
  "暂无建议 — 点击\"运行调优引擎\"": {
    "en": "No suggestions yet — Click \"Run Optimization Engine\"",
    "ja": "まだ提案がありません — 「最適化エンジンを実行」をクリック",
    "de": "Noch keine Vorschläge — Klicken Sie auf \"Optimierungs-Engine ausführen\"",
    "fr": "Aucune suggestion pour l'instant — Cliquez sur \"Exécuter le moteur d'optimisation\"",
    "es": "Aún no hay sugerencias — Haga clic en \"Ejecutar motor de optimización\""
  },
  "广告渠道归因（基于 Shopify 真实订单 UTM）": {
    "en": "Ad Channel Attribution (Based on Shopify Real Order UTM)",
    "ja": "広告チャネルアトリビューション（Shopifyの実際の注文UTMに基づく）",
    "de": "Werbekanal-Attribution (basierend auf Shopify echten Bestell-UTM)",
    "fr": "Attribution des canaux publicitaires (basée sur l'UTM des commandes réelles Shopify)",
    "es": "Atribución de canales publicitarios (basada en UTM de pedidos reales de Shopify)"
  },
  "系列/UTM": {
    "en": "Campaign/UTM",
    "ja": "シリーズ/UTM",
    "de": "Kampagne/UTM",
    "fr": "Campagne/UTM",
    "es": "Campaña/UTM"
  },
  "收入": {
    "en": "Revenue",
    "ja": "収益",
    "de": "Umsatz",
    "fr": "Revenu",
    "es": "Ingresos"
  },
  "暂无归因数据 — 在\"广告系列\"页执行订单归因": {
    "en": "No attribution data — perform order attribution on Campaigns page",
    "ja": "アトリビューションデータなし — 「キャンペーン」ページで注文アトリビューションを実行",
    "de": "Keine Attributionsdaten — führen Sie die Auftragsattribution auf der Seite \"Kampagnen\" durch",
    "fr": "Aucune donnée d'attribution — effectuez l'attribution des commandes sur la page Campagnes",
    "es": "Sin datos de atribución — realice la atribución de pedidos en la página Campañas"
  },
  "广告预算自主优化 — Meta/Google 监控 · UTM 归因 · ROAS 调优": {
    "en": "Autonomous ad budget optimization — Meta/Google monitoring · UTM attribution · ROAS tuning",
    "ja": "広告予算の自動最適化 — Meta/Google 監視 · UTM アトリビューション · ROAS チューニング",
    "de": "Autonome Optimierung des Werbebudgets — Meta/Google-Überwachung · UTM-Attribution · ROAS-Optimierung",
    "fr": "Optimisation autonome du budget publicitaire — Surveillance Meta/Google · Attribution UTM · Ajustement ROAS",
    "es": "Optimización autónoma del presupuesto publicitario — Monitoreo Meta/Google · Atribución UTM · Ajuste de ROAS"
  },
  "广告系列": {
    "en": "Campaigns",
    "ja": "キャンペーン",
    "de": "Kampagnen",
    "fr": "Campagnes",
    "es": "Campañas"
  },
  "预算调优": {
    "en": "Budget Tuning",
    "ja": "予算調整",
    "de": "Budgetoptimierung",
    "fr": "Ajustement du budget",
    "es": "Ajuste de presupuesto"
  },
  "归因统计": {
    "en": "Attribution Stats",
    "ja": "アトリビューション統計",
    "de": "Attributionsstatistiken",
    "fr": "Statistiques d'attribution",
    "es": "Estadísticas de atribución"
  },
  "/api/v1/assets": {
    "en": "/api/v1/assets",
    "ja": "/api/v1/assets",
    "de": "/api/v1/assets",
    "fr": "/api/v1/assets",
    "es": "/api/v1/assets"
  },
  "请填写素材 URL": {
    "en": "Please enter the asset URL",
    "ja": "素材URLを入力してください",
    "de": "Bitte geben Sie die Asset-URL ein",
    "fr": "Veuillez saisir l'URL de l'asset",
    "es": "Por favor, ingrese la URL del activo"
  },
  "素材 URL（图片/视频封面）": {
    "en": "Asset URL (image/video cover)",
    "ja": "素材URL（画像/動画カバー）",
    "de": "Asset-URL (Bild/Video-Cover)",
    "fr": "URL de l'asset (couverture image/vidéo)",
    "es": "URL del activo (portada de imagen/video)"
  },
  "图片": {
    "en": "Image",
    "ja": "画像",
    "de": "Bild",
    "fr": "Image",
    "es": "Imagen"
  },
  "视频": {
    "en": "Video",
    "ja": "動画",
    "de": "Video",
    "fr": "Vidéo",
    "es": "Video"
  },
  "创作者 @": {
    "en": "Creator @",
    "ja": "クリエイター @",
    "de": "Ersteller @",
    "fr": "Créateur @",
    "es": "Creador @"
  },
  "＋ 添加素材": {
    "en": "+ Add Asset",
    "ja": "＋ 素材を追加",
    "de": "+ Asset hinzufügen",
    "fr": "+ Ajouter un asset",
    "es": "+ Agregar activo"
  },
  "素材详情": {
    "en": "Asset Details",
    "ja": "素材詳細",
    "de": "Asset-Details",
    "fr": "Détails de l'asset",
    "es": "Detalles del activo"
  },
  "📝 多平台文案": {
    "en": "📝 Multi-platform Copy",
    "ja": "📝 マルチプラットフォームコピー",
    "de": "📝 Multiplattform-Text",
    "fr": "📝 Copie multi-plateforme",
    "es": "📝 Copia multiplataforma"
  },
  "素材": {
    "en": "Asset",
    "ja": "素材",
    "de": "Asset",
    "fr": "Asset",
    "es": "Activo"
  },
  "创作者": {
    "en": "Creator",
    "ja": "クリエイター",
    "de": "Ersteller",
    "fr": "Créateur",
    "es": "Creador"
  },
  "🔍 高光分析": {
    "en": "🔍 Highlight Analysis",
    "ja": "🔍 ハイライト分析",
    "de": "🔍 Highlight-Analyse",
    "fr": "🔍 Analyse des points forts",
    "es": "🔍 Análisis de destacados"
  },
  "📝 生成文案": {
    "en": "📝 Generate Copy",
    "ja": "📝 コピー生成",
    "de": "📝 Text generieren",
    "fr": "📝 Générer du texte",
    "es": "📝 Generar copia"
  },
  "暂无素材": {
    "en": "No assets yet",
    "ja": "素材がありません",
    "de": "Noch keine Assets",
    "fr": "Aucun asset pour l'instant",
    "es": "Aún no hay activos"
  },
  "/api/v1/fatigue": {
    "en": "/api/v1/fatigue",
    "ja": "/api/v1/fatigue",
    "de": "/api/v1/fatigue",
    "fr": "/api/v1/fatigue",
    "es": "/api/v1/fatigue"
  },
  "近期曝光数？": {
    "en": "Recent impressions?",
    "ja": "最近のインプレッション数？",
    "de": "Aktuelle Impressionen?",
    "fr": "Impressions récentes ?",
    "es": "¿Impresiones recientes?"
  },
  "近期点击数？": {
    "en": "Recent clicks?",
    "ja": "最近のクリック数？",
    "de": "Aktuelle Klicks?",
    "fr": "Clics récents ?",
    "es": "¿Clics recientes?"
  },
  "素材疲劳监控（CTR 衰减检测）": {
    "en": "Asset Fatigue Monitoring (CTR decay detection)",
    "ja": "素材疲労監視（CTR減衰検出）",
    "de": "Asset-Ermüdungsüberwachung (CTR-Abfallerkennung)",
    "fr": "Surveillance de la fatigue des assets (détection de baisse du CTR)",
    "es": "Monitoreo de fatiga de activos (detección de caída de CTR)"
  },
  "疲劳分": {
    "en": "Fatigue Score",
    "ja": "疲労スコア",
    "de": "Ermüdungswert",
    "fr": "Score de fatigue",
    "es": "Puntuación de fatiga"
  },
  "录入投放数据": {
    "en": "Enter delivery data",
    "ja": "配信データを入力",
    "de": "Auslieferungsdaten eingeben",
    "fr": "Saisir les données de diffusion",
    "es": "Ingresar datos de entrega"
  },
  "暂无已分析素材": {
    "en": "No analyzed assets yet",
    "ja": "分析済み素材はまだありません",
    "de": "Noch keine analysierten Assets",
    "fr": "Aucun asset analysé pour l'instant",
    "es": "Aún no hay activos analizados"
  },
  "UGC 视频提炼与素材转化 — 高光提取 · 多平台文案 · 疲劳检测": {
    "en": "UGC video extraction & asset conversion — highlight extraction · multi-platform copy · fatigue detection",
    "ja": "UGC動画の抽出と素材変換 — ハイライト抽出 · マルチプラットフォームコピー · 疲労検出",
    "de": "UGC-Videoextraktion & Asset-Konvertierung — Highlight-Extraktion · Multiplattform-Text · Ermüdungserkennung",
    "fr": "Extraction de vidéos UGC et conversion d'assets — extraction des points forts · copie multi-plateforme · détection de fatigue",
    "es": "Extracción de videos UGC y conversión de activos — extracción de destacados · copia multiplataforma · detección de fatiga"
  },
  "素材库": {
    "en": "Asset Library",
    "ja": "素材ライブラリ",
    "de": "Asset-Bibliothek",
    "fr": "Bibliothèque d'assets",
    "es": "Biblioteca de activos"
  },
  "疲劳监控": {
    "en": "Fatigue Monitoring",
    "ja": "疲労監視",
    "de": "Ermüdungsüberwachung",
    "fr": "Surveillance de la fatigue",
    "es": "Monitoreo de fatiga"
  }
};
